
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2rynm", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $jmjWc = parcelRequire("jmjWc");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $io723 = parcelRequire("io723");


var $gz8ZY = parcelRequire("gz8ZY");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");








var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $2W0qg = parcelRequire("2W0qg");


var $hmuev = parcelRequire("hmuev");


var $6xdDU = parcelRequire("6xdDU");


var $ep3mz = parcelRequire("ep3mz");


var $1I9Gw = parcelRequire("1I9Gw");













var $ccHMk = parcelRequire("ccHMk");


var $cO1el = parcelRequire("cO1el");


var $1Whri = parcelRequire("1Whri");


var $8tdj3 = parcelRequire("8tdj3");


var $auNCB = parcelRequire("auNCB");





var $eyWa4 = parcelRequire("eyWa4");







var $1DHa6 = parcelRequire("1DHa6");

var $9ot3w = parcelRequire("9ot3w");


var $ghftu = parcelRequire("ghftu");


var $2AytZ = parcelRequire("2AytZ");


var $jdPfT = parcelRequire("jdPfT");


var $9hlns = parcelRequire("9hlns");


var $7aA9P = parcelRequire("7aA9P");


var $lsxnT = parcelRequire("lsxnT");











var $imt6g = parcelRequire("imt6g");


var $7yDmn = parcelRequire("7yDmn");







const $5ff49e7a1b080355$var$styles = {
    pressable: "_1rjcutpp _1e0c1txw _4cvr1h6o _1bah1h6o _bozgpxbi _y4tipxbi _bfhk1j28 _1o9zidpf _irr31j28",
    highlightRing: "_2rko1rr0 _1mou196n _195g196n _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _irr3plhp",
    iconWrapper: "_kqswh2mm _1bsb7vkz _4t3i7vkz _1o9zidpf",
    iconLayer: "_v56414mc _kqswstnw _154iidpf _1ltvidpf",
    iconLayerVisible: "_tzy4kb7n _t9ec1h7a",
    iconLayerHidden: "_tzy4idpf _t9ec18p1"
};
const $5ff49e7a1b080355$export$7eb83caae4372066 = (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { isSelected: isSelected, onClick: onClick, ariaLabel: ariaLabel } = t0;
    const t1 = isSelected ? $5ff49e7a1b080355$var$styles.iconLayerVisible : $5ff49e7a1b080355$var$styles.iconLayerHidden;
    let t2;
    if ($[0] !== t1) {
        t2 = (0, $1Whri.cx)($5ff49e7a1b080355$var$styles.iconLayer, t1);
        $[0] = t1;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($imt6g))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        });
        $[2] = t3;
    } else t3 = $[2];
    let t4;
    if ($[3] !== t2) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t2
        }, t3);
        $[3] = t2;
        $[4] = t4;
    } else t4 = $[4];
    const t5 = isSelected ? $5ff49e7a1b080355$var$styles.iconLayerHidden : $5ff49e7a1b080355$var$styles.iconLayerVisible;
    let t6;
    if ($[5] !== t5) {
        t6 = (0, $1Whri.cx)($5ff49e7a1b080355$var$styles.iconLayer, t5);
        $[5] = t5;
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7yDmn))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t6
        }, t7);
        $[8] = t6;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== t4 || $[11] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5ff49e7a1b080355$var$styles.highlightRing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $5ff49e7a1b080355$var$styles.iconWrapper
        }, t4, t8));
        $[10] = t4;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    let t10;
    if ($[13] !== ariaLabel || $[14] !== onClick || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $5ff49e7a1b080355$var$styles.pressable,
            onClick: onClick,
            "aria-label": ariaLabel
        }, t9);
        $[13] = ariaLabel;
        $[14] = onClick;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
};





/**
 * @generated SignedSource<<e1461337ea6e9b3d7422c03a23ca2cf9>>
 * @relayHash afe0901b48e911b10f7b851c09b7931f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bd98b03ab887daa0808adad76c005fcfdb15914d41890abaf26048a8b6fcda4f
const $ffebeb9f14c82074$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ids"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "ids",
                    "variableName": "ids"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useContentTitlesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useContentTitlesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "afe0901b48e911b10f7b851c09b7931f",
            "id": "bd98b03ab887daa0808adad76c005fcfdb15914d41890abaf26048a8b6fcda4f",
            "metadata": {},
            "name": "useContentTitlesQuery",
            "operationKind": "query",
            "text": "query useContentTitlesQuery($ids:[ID!]!){content(ids:$ids){nodes{id,title}}}"
        }
    };
}();
$ffebeb9f14c82074$var$node.hash = "55f695ceabd6367765c49b523c7e2f29";
var $ffebeb9f14c82074$export$2e2bcd8739ae039 = $ffebeb9f14c82074$var$node;



var $jMyy4 = parcelRequire("jMyy4");

const $d765c8713688ab6e$var$ContentTitlesQuery = (0, $ffebeb9f14c82074$export$2e2bcd8739ae039);
const $d765c8713688ab6e$export$7610585fadab893e = (contentIds)=>{
    const $ = (0, $frIzR.c)(14);
    let t0;
    if ($[0] !== contentIds) {
        t0 = new Set(contentIds);
        $[0] = contentIds;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== t0) {
        t1 = [
            ...t0
        ].filter(Boolean);
        $[2] = t0;
        $[3] = t1;
    } else t1 = $[3];
    const unique = t1;
    const ids = unique;
    let t2;
    if ($[4] !== ids) {
        t2 = {
            ids: ids
        };
        $[4] = ids;
        $[5] = t2;
    } else t2 = $[5];
    const t3 = ids.length === 0;
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = {
            variables: t2,
            skip: t3
        };
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    const { data: data, loading: loading } = (0, $jMyy4.useQueryInterop)($d765c8713688ab6e$var$ContentTitlesQuery, t4);
    let map;
    if ($[9] !== data?.content?.nodes) {
        map = new Map();
        const nodes = data?.content?.nodes ?? [];
        for (const node of nodes)if (node?.id != null) map.set(node.id, node.title ?? "");
        $[9] = data?.content?.nodes;
        $[10] = map;
    } else map = $[10];
    const titlesByContentId = map;
    const isLoading = ids.length > 0 && loading;
    let t5;
    if ($[11] !== isLoading || $[12] !== titlesByContentId) {
        t5 = {
            titlesByContentId: titlesByContentId,
            isLoading: isLoading
        };
        $[11] = isLoading;
        $[12] = titlesByContentId;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};



var $f7B1p = parcelRequire("f7B1p");

var $090b31fb8b21ef86$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action["SUGGEST"] = "SUGGEST";
    Action["ACCEPT"] = "ACCEPT";
    Action["REJECT"] = "REJECT";
    return Action;
}({});
const $090b31fb8b21ef86$export$51b10001420b4ba3 = [
    {
        pattern: 'docs.google.com/document',
        product: 'Google Docs',
        productKey: 'googleDocs',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'docs.google.com/spreadsheets',
        product: 'Google Sheets',
        productKey: 'googleSheets',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png'
    },
    {
        pattern: 'docs.google.com/presentation',
        product: 'Google Slides',
        productKey: 'googleSlides',
        iconUrl: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico'
    },
    {
        pattern: 'drive.google.com',
        product: 'Google Drive',
        productKey: 'googleDrive',
        iconUrl: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png'
    },
    {
        pattern: 'loom.com',
        product: 'Loom',
        productKey: 'loom',
        iconUrl: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico'
    },
    {
        pattern: 'figma.com',
        product: 'Figma',
        productKey: 'figma',
        iconUrl: 'https://static.figma.com/app/icon/1/favicon.ico'
    },
    {
        pattern: 'slack.com',
        product: 'Slack',
        productKey: 'slack',
        iconUrl: 'https://slack.com/favicon.ico'
    }
];
const $090b31fb8b21ef86$export$9911254b1f812303 = {
    productKey: 'link',
    iconUrl: ''
};


const $3b31958c77e1b16d$export$c9239e53ef385494 = (spaceKey)=>{
    const submitActions = (allSuggestions, selectedIds)=>{
        if (!spaceKey) return;
        const actions = allSuggestions.map((s)=>({
                ...s,
                action: selectedIds.has(s.id) ? (0, $090b31fb8b21ef86$export$e19cd5f9376f8cee).ACCEPT : (0, $090b31fb8b21ef86$export$e19cd5f9376f8cee).REJECT
            }));
        (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/actions`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                actions: actions
            })
        });
    };
    return {
        submitActions: submitActions
    };
};


















const $c5ab38ff0f87742b$export$c035d51031d22758 = {
    google_drive: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png',
    google_docs: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_document_x32.png',
    google_sheets: 'https://ssl.gstatic.com/docs/doclist/images/mediatype/icon_1_spreadsheet_x32.png',
    google_slides: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico',
    loom: 'https://cdn.loom.com/assets/favicons-loom/favicon.ico',
    figma: 'https://static.figma.com/app/icon/1/favicon.ico',
    slack: 'https://slack.com/favicon.ico'
};
const $c5ab38ff0f87742b$var$DEFAULT_ICON_URL = '';
function $c5ab38ff0f87742b$var$normalizeContentType(type) {
    return type.toLowerCase().replace(/\s+/g, '_');
}
function $c5ab38ff0f87742b$export$54e0f9305a4808e9(contentType) {
    const key = $c5ab38ff0f87742b$var$normalizeContentType(contentType);
    return $c5ab38ff0f87742b$export$c035d51031d22758[key] ?? $c5ab38ff0f87742b$var$DEFAULT_ICON_URL;
}
const $c5ab38ff0f87742b$var$styles = {
    wrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    iconSlot: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqx0bf _kqswh2mm",
    iconSlotFirst: "_2rko12b0 _1o9zidpf _1e0c1txw _4cvr1h6o _1bah1h6o _ahbqidpf _kqswh2mm",
    smallIcon: "_1bsb7vkz _4t3i7vkz",
    largeIcon: "_1bsbvbgk _4t3ivbgk"
};
const $c5ab38ff0f87742b$var$ICON_SIZE = {
    small: 16,
    large: 28
};
const $c5ab38ff0f87742b$var$iconZIndex = (index, total)=>total - index;
const $c5ab38ff0f87742b$export$98526f0dffd4f41b = (t0)=>{
    const $ = (0, $frIzR.c)(12);
    const { contentTypes: contentTypes, variant: t1, testId: t2 } = t0;
    const variant = t1 === undefined ? "small" : t1;
    const testId = t2 === undefined ? "stacked-content-type-icons" : t2;
    let T0;
    let t3;
    let t4;
    let t5;
    if ($[0] !== contentTypes || $[1] !== testId || $[2] !== variant) {
        const displayTypes = (contentTypes ?? []).slice(0, 3);
        const iconUrls = displayTypes.map($c5ab38ff0f87742b$var$_temp);
        T0 = (0, $gdv5Z.default);
        t3 = $c5ab38ff0f87742b$var$styles.wrapper;
        t4 = testId;
        t5 = iconUrls.length > 0 ? iconUrls.map((url, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                key: `${displayTypes[i]}-${i}`,
                xcss: i === 0 ? $c5ab38ff0f87742b$var$styles.iconSlotFirst : $c5ab38ff0f87742b$var$styles.iconSlot,
                style: {
                    zIndex: $c5ab38ff0f87742b$var$iconZIndex(i, iconUrls.length)
                },
                "aria-hidden": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
                src: url,
                width: $c5ab38ff0f87742b$var$ICON_SIZE[variant],
                height: $c5ab38ff0f87742b$var$ICON_SIZE[variant],
                fallback: $c5ab38ff0f87742b$var$_temp2,
                role: "presentation"
            }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "currentColor"
        });
        $[0] = contentTypes;
        $[1] = testId;
        $[2] = variant;
        $[3] = T0;
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else {
        T0 = $[3];
        t3 = $[4];
        t4 = $[5];
        t5 = $[6];
    }
    let t6;
    if ($[7] !== T0 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            xcss: t3,
            testId: t4
        }, t5);
        $[7] = T0;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
        $[11] = t6;
    } else t6 = $[11];
    return t6;
};
function $c5ab38ff0f87742b$var$_temp(t) {
    return $c5ab38ff0f87742b$export$54e0f9305a4808e9(t);
}
function $c5ab38ff0f87742b$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}


const $b84c4cb49dedd5e2$var$i18n = (0, $cgtv4.defineMessages)({
    bringTogetherTitle: {
        id: "side-navigation.review-content-suggestions-modal.bring-together-title",
        defaultMessage: "Bring together the content that matters"
    },
    bringTogetherDescription: {
        id: "side-navigation.review-content-suggestions-modal.bring-together-description",
        defaultMessage: "Add these suggestions and it\u2019ll be organized in this space."
    },
    addItemsToSpace: {
        id: "side-navigation.review-content-suggestions-modal.add-items-to-space",
        defaultMessage: "Add {count, plural, one {# item} other {# items}} to space"
    },
    expandGroup: {
        id: "side-navigation.review-content-suggestions-modal.expand-group",
        defaultMessage: "Expand {title}"
    },
    collapseGroup: {
        id: "side-navigation.review-content-suggestions-modal.collapse-group",
        defaultMessage: "Collapse {title}"
    },
    openSuggestion: {
        id: "side-navigation.review-content-suggestions-modal.open-suggestion",
        defaultMessage: "Open {title} in a new tab"
    },
    deselectGroup: {
        id: "side-navigation.review-content-suggestions-modal.deselect-group",
        defaultMessage: "Deselect group {title}"
    },
    selectGroup: {
        id: "side-navigation.review-content-suggestions-modal.select-group",
        defaultMessage: "Select group {title}"
    },
    deselectItem: {
        id: "side-navigation.review-content-suggestions-modal.deselect-item",
        defaultMessage: "Deselect {title}"
    },
    selectItem: {
        id: "side-navigation.review-content-suggestions-modal.select-item",
        defaultMessage: "Select {title}"
    },
    untitled: {
        id: "side-navigation.review-content-suggestions-modal.untitled",
        defaultMessage: "Untitled"
    },
    loading: {
        id: "side-navigation.review-content-suggestions-modal.loading",
        defaultMessage: "Loading suggestions\u2026"
    },
    hoverCardFallbackDescription: {
        id: "side-navigation.review-content-suggestions-modal.hover-card-fallback-description",
        defaultMessage: "Open this item in a new tab to view it in {product}."
    },
    openHoverCardSuggestion: {
        id: "side-navigation.review-content-suggestions-modal.open-hover-card-suggestion",
        defaultMessage: "Open item"
    },
    productGoogleDocs: {
        id: "side-navigation.review-content-suggestions-modal.product-google-docs.no-translate",
        defaultMessage: "Google Docs"
    },
    productGoogleSheets: {
        id: "side-navigation.review-content-suggestions-modal.product-google-sheets.no-translate",
        defaultMessage: "Google Sheets"
    },
    productGoogleSlides: {
        id: "side-navigation.review-content-suggestions-modal.product-google-slides.no-translate",
        defaultMessage: "Google Slides"
    },
    productGoogleDrive: {
        id: "side-navigation.review-content-suggestions-modal.product-google-drive.no-translate",
        defaultMessage: "Google Drive"
    },
    productLoom: {
        id: "side-navigation.review-content-suggestions-modal.product-loom.no-translate",
        defaultMessage: "Loom"
    },
    productFigma: {
        id: "side-navigation.review-content-suggestions-modal.product-figma.no-translate",
        defaultMessage: "Figma"
    },
    productSlack: {
        id: "side-navigation.review-content-suggestions-modal.product-slack.no-translate",
        defaultMessage: "Slack"
    },
    productLink: {
        id: "side-navigation.review-content-suggestions-modal.product-link",
        defaultMessage: "Link"
    }
});
function $b84c4cb49dedd5e2$var$getSuggestionProductInfo(url) {
    const productInfo = (0, $090b31fb8b21ef86$export$51b10001420b4ba3).find((entry)=>url.includes(entry.pattern));
    return productInfo ?? (0, $090b31fb8b21ef86$export$9911254b1f812303);
}
const $b84c4cb49dedd5e2$var$PRODUCT_LABEL_MESSAGES = {
    googleDocs: $b84c4cb49dedd5e2$var$i18n.productGoogleDocs,
    googleSheets: $b84c4cb49dedd5e2$var$i18n.productGoogleSheets,
    googleSlides: $b84c4cb49dedd5e2$var$i18n.productGoogleSlides,
    googleDrive: $b84c4cb49dedd5e2$var$i18n.productGoogleDrive,
    loom: $b84c4cb49dedd5e2$var$i18n.productLoom,
    figma: $b84c4cb49dedd5e2$var$i18n.productFigma,
    slack: $b84c4cb49dedd5e2$var$i18n.productSlack,
    link: $b84c4cb49dedd5e2$var$i18n.productLink
};
function $b84c4cb49dedd5e2$var$getProductLabelMessage(productKey) {
    return $b84c4cb49dedd5e2$var$PRODUCT_LABEL_MESSAGES[productKey];
}
const $b84c4cb49dedd5e2$var$styles = {
    layout: "_2rkopb1k _4t3icv93",
    leftPanel: "_zulp1ejb _1rjc1jfw _18zrpxbi _16jlkb7n _i0dl1ssb _1e0c1txw _2lx21bp4 _18m91wug",
    rightPanel: "_16jlkb7n _i0dl1ssb _bfhkrwxf _18m91wug _kqswh2mm",
    stackedContentTypeIconWrapper: "_6rthv47k",
    closeButtonWrapper: "_154iutpp _1ltvutpp",
    groupListScrollArea: "_16jlkb7n _18m91wug _1fjgglyw _1tkeidpf",
    hoverCard: "_2rko1mok _1yt4utpp _189ee4h9 _1dqonqa1 _1h6d1l7x _1bsbgx0z _bfhk1j9a _16qs130s",
    hoverCardContent: "_p12f1osq _1ul9idpf",
    hoverCardTitle: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _p12f1osq",
    hoverCardDescription: "_1reo15vq _18m915vq _1bto1l2s _1e0ccj1k _sudp1e54 _syazazsu _1yyjcs5v _p12f1osq",
    hoverCardFooter: "_195g1410 _18zrpxbi _uwhke4h9 _15a5nqa1 _1i531l7x _1q51u2gc _syazazsu",
    hoverCardIcon: "_1bsbdlk8 _4t3idlk8 _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    hoverCardOpenLink: "_zulp1b66 _4bfu1r31 _1hmsglyw _ajmmnqa1 _1e0c116y _4cvr1h6o",
    groupCard: "_2rko1mok _1reo15vq _18m915vq _v5641po6 _189ee4h9 _1dqonqa1 _1h6d1l7x _4cvx1ihb",
    groupCardExpanded: "_1reoewfl _18m9ewfl _1h6d1ihb _kqswh2mm _1pbyidpf",
    groupCardHovering: "_1h6d1l7x _kqswh2mm _1pby1fw0",
    groupHeaderCard: "_1rjcu2gc",
    expandButton: "_zulpu2gc _1rjcutpp _1e0c1txw _4cvr1h6o _1bah1y6m _y3gnv2br _16jlkb7n _bozg1b66 _y4tiutpp _bfhk1j28 _irr31j28",
    groupTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    itemsListOuter: "_v5641i4b _1e0c11p5 _2z0563bf _tzy4idpf",
    itemsListOuterExpanded: "_2z05hkll _tzy4kb7n",
    itemsList: "_1reoewfl _18m9ewfl _1tkeidpf",
    itemRowContainer: "_kqswh2mm _1pbyidpf",
    itemRowContainerHovered: "_1pbykb7n",
    inlineHoverCardWrapper: "_v564sfsx _kqswstnw _154i1jfw _1ltv1jfw _19pk1b66 _tzy4idpf _lcxvglyw _t9ec155f",
    inlineHoverCardWrapperVisible: "_tzy4kb7n _lcxv1wug _t9ec1kli",
    inlineHoverCardShadowLayer: "_kqswh2mm _1pbyb4wl",
    suggestionLinkWrapper: "_16jlkb7n _1ul9idpf",
    suggestionLink: "_zulpu2gc _4bfu1r31 _1hmsglyw _ajmmnqa1 _1rjc12x7 _1e0c1txw _4cvr1h6o _1n261q9c _1ul9idpf _bozg1b66 _y4tiutpp _syazi7uo _9oik1r31 _1bnxglyw _jf4cnqa1",
    suggestionIconSlot: "_1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf",
    suggestionTitleWrapper: "_1reo15vq _18m915vq _16jlkb7n _1ul9idpf",
    suggestionLinkExternalIcon: "_1o9zidpf",
    addButtonRow: "_85i5pxbi",
    itemRow: "_1rjcu2gc _uwhke4h9 _15a5nqa1 _1i531l7x _irr3i8nm",
    unselectedOpacity: "_tzy42wxo",
    loadingOverlay: "_1e0c1txw _4cvr1h6o _1bah1h6o _1tkeufrr"
};
const $b84c4cb49dedd5e2$var$SuggestionHoverCard = (t0)=>{
    const $ = (0, $frIzR.c)(26);
    const { suggestion: suggestion } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let iconUrl;
    let product;
    let t1;
    if ($[0] !== formatMessage || $[1] !== suggestion.description || $[2] !== suggestion.url) {
        const { productKey: productKey, iconUrl: t2 } = $b84c4cb49dedd5e2$var$getSuggestionProductInfo(suggestion.url);
        iconUrl = t2;
        product = formatMessage($b84c4cb49dedd5e2$var$getProductLabelMessage(productKey));
        t1 = suggestion.description?.trim() ? suggestion.description : formatMessage($b84c4cb49dedd5e2$var$i18n.hoverCardFallbackDescription, {
            product: product
        });
        $[0] = formatMessage;
        $[1] = suggestion.description;
        $[2] = suggestion.url;
        $[3] = iconUrl;
        $[4] = product;
        $[5] = t1;
    } else {
        iconUrl = $[3];
        product = $[4];
        t1 = $[5];
    }
    const description = t1;
    let t2;
    if ($[6] !== iconUrl) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.hoverCardIcon,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "14",
            height: "14",
            fallback: $b84c4cb49dedd5e2$var$_temp,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[6] = iconUrl;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== suggestion.title) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.025",
            xcss: $b84c4cb49dedd5e2$var$styles.hoverCardContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.hoverCardTitle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            weight: "medium",
            color: "color.text.accent.blue"
        }, suggestion.title)));
        $[8] = suggestion.title;
        $[9] = t3;
    } else t3 = $[9];
    let t4;
    if ($[10] !== t2 || $[11] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100"
        }, t2, t3);
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== description) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.hoverCardDescription
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, description));
        $[13] = description;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== iconUrl) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.hoverCardIcon,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "14",
            height: "14",
            fallback: $b84c4cb49dedd5e2$var$_temp2,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[15] = iconUrl;
        $[16] = t6;
    } else t6 = $[16];
    let t7;
    if ($[17] !== product) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle"
        }, product);
        $[17] = product;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== t6 || $[20] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            gap: "space.100",
            xcss: $b84c4cb49dedd5e2$var$styles.hoverCardFooter
        }, t6, t7);
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    let t9;
    if ($[22] !== t4 || $[23] !== t5 || $[24] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.150",
            xcss: $b84c4cb49dedd5e2$var$styles.hoverCard,
            testId: "review-content-suggestion-hover-card"
        }, t4, t5, t8);
        $[22] = t4;
        $[23] = t5;
        $[24] = t8;
        $[25] = t9;
    } else t9 = $[25];
    return t9;
};
const $b84c4cb49dedd5e2$var$SuggestionItemRow = (t0)=>{
    const $ = (0, $frIzR.c)(58);
    const { suggestion: suggestion, isSelected: isSelected, onToggleSelectItem: onToggleSelectItem, onHoverCardVisibilityChange: onHoverCardVisibilityChange } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== suggestion.url) {
        t1 = $b84c4cb49dedd5e2$var$getSuggestionProductInfo(suggestion.url);
        $[0] = suggestion.url;
        $[1] = t1;
    } else t1 = $[1];
    const { iconUrl: iconUrl } = t1;
    const [isHoverCardVisible, setIsHoverCardVisible] = (0, $42omo.useState)(false);
    const t2 = isHoverCardVisible && $b84c4cb49dedd5e2$var$styles.itemRowContainerHovered;
    let t3;
    if ($[2] !== t2) {
        t3 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemRowContainer, t2);
        $[2] = t2;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    let t5;
    let t6;
    let t7;
    if ($[4] !== onHoverCardVisibilityChange) {
        t4 = ()=>{
            setIsHoverCardVisible(true);
            onHoverCardVisibilityChange(true);
        };
        t5 = ()=>{
            setIsHoverCardVisible(false);
            onHoverCardVisibilityChange(false);
        };
        t6 = ()=>{
            setIsHoverCardVisible(true);
            onHoverCardVisibilityChange(true);
        };
        t7 = ()=>{
            setIsHoverCardVisible(false);
            onHoverCardVisibilityChange(false);
        };
        $[4] = onHoverCardVisibilityChange;
        $[5] = t4;
        $[6] = t5;
        $[7] = t6;
        $[8] = t7;
    } else {
        t4 = $[5];
        t5 = $[6];
        t6 = $[7];
        t7 = $[8];
    }
    const t8 = `review-content-suggestion-row-${suggestion.id}`;
    const t9 = !isSelected && $b84c4cb49dedd5e2$var$styles.unselectedOpacity;
    let t10;
    if ($[9] !== t9) {
        t10 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemRow, t9);
        $[9] = t9;
        $[10] = t10;
    } else t10 = $[10];
    let t11;
    if ($[11] !== onToggleSelectItem || $[12] !== suggestion.id) {
        t11 = ()=>onToggleSelectItem(suggestion.id);
        $[11] = onToggleSelectItem;
        $[12] = suggestion.id;
        $[13] = t11;
    } else t11 = $[13];
    const t12 = isSelected ? $b84c4cb49dedd5e2$var$i18n.deselectItem : $b84c4cb49dedd5e2$var$i18n.selectItem;
    let t13;
    if ($[14] !== formatMessage || $[15] !== suggestion.title || $[16] !== t12) {
        t13 = formatMessage(t12, {
            title: suggestion.title
        });
        $[14] = formatMessage;
        $[15] = suggestion.title;
        $[16] = t12;
        $[17] = t13;
    } else t13 = $[17];
    let t14;
    if ($[18] !== isSelected || $[19] !== t11 || $[20] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ff49e7a1b080355$export$7eb83caae4372066), {
            isSelected: isSelected,
            onClick: t11,
            ariaLabel: t13
        });
        $[18] = isSelected;
        $[19] = t11;
        $[20] = t13;
        $[21] = t14;
    } else t14 = $[21];
    const t15 = suggestion.url;
    let t16;
    if ($[22] !== formatMessage || $[23] !== suggestion.title) {
        t16 = formatMessage($b84c4cb49dedd5e2$var$i18n.openSuggestion, {
            title: suggestion.title
        });
        $[22] = formatMessage;
        $[23] = suggestion.title;
        $[24] = t16;
    } else t16 = $[24];
    let t17;
    if ($[25] !== iconUrl) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionIconSlot,
            "aria-hidden": "true"
        }, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7aA9P.FallbackableImage), {
            src: iconUrl,
            width: "16",
            height: "16",
            fallback: $b84c4cb49dedd5e2$var$_temp3,
            role: "presentation"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[25] = iconUrl;
        $[26] = t17;
    } else t17 = $[26];
    let t18;
    if ($[27] !== suggestion.title) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            maxLines: 1
        }, suggestion.title));
        $[27] = suggestion.title;
        $[28] = t18;
    } else t18 = $[28];
    let t19;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLinkExternalIcon,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }));
        $[29] = t19;
    } else t19 = $[29];
    let t20;
    if ($[30] !== suggestion.url || $[31] !== t16 || $[32] !== t17 || $[33] !== t18) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLinkWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auNCB.default), {
            href: t15,
            target: "_blank",
            rel: "noopener noreferrer",
            "aria-label": t16,
            xcss: $b84c4cb49dedd5e2$var$styles.suggestionLink
        }, t17, t18, t19));
        $[30] = suggestion.url;
        $[31] = t16;
        $[32] = t17;
        $[33] = t18;
        $[34] = t20;
    } else t20 = $[34];
    let t21;
    if ($[35] !== t10 || $[36] !== t14 || $[37] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center",
            xcss: t10
        }, t14, t20);
        $[35] = t10;
        $[36] = t14;
        $[37] = t20;
        $[38] = t21;
    } else t21 = $[38];
    const t22 = isHoverCardVisible && $b84c4cb49dedd5e2$var$styles.inlineHoverCardWrapperVisible;
    let t23;
    if ($[39] !== t22) {
        t23 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.inlineHoverCardWrapper, t22);
        $[39] = t22;
        $[40] = t23;
    } else t23 = $[40];
    let t24;
    if ($[41] !== isHoverCardVisible || $[42] !== suggestion) {
        t24 = isHoverCardVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionHoverCard, {
            suggestion: suggestion
        }) : null;
        $[41] = isHoverCardVisible;
        $[42] = suggestion;
        $[43] = t24;
    } else t24 = $[43];
    let t25;
    if ($[44] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.inlineHoverCardShadowLayer
        }, t24);
        $[44] = t24;
        $[45] = t25;
    } else t25 = $[45];
    let t26;
    if ($[46] !== t23 || $[47] !== t25) {
        t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t23
        }, t25);
        $[46] = t23;
        $[47] = t25;
        $[48] = t26;
    } else t26 = $[48];
    let t27;
    if ($[49] !== t21 || $[50] !== t26 || $[51] !== t3 || $[52] !== t4 || $[53] !== t5 || $[54] !== t6 || $[55] !== t7 || $[56] !== t8) {
        t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t3,
            onMouseEnter: t4,
            onMouseLeave: t5,
            onFocusCapture: t6,
            onBlur: t7,
            testId: t8
        }, t21, t26);
        $[49] = t21;
        $[50] = t26;
        $[51] = t3;
        $[52] = t4;
        $[53] = t5;
        $[54] = t6;
        $[55] = t7;
        $[56] = t8;
        $[57] = t27;
    } else t27 = $[57];
    return t27;
};
const $b84c4cb49dedd5e2$var$SuggestionGroupRow = (t0)=>{
    const $ = (0, $frIzR.c)(63);
    const { parentTitle: parentTitle, suggestions: suggestions, isExpanded: isExpanded, isGroupSelected: isGroupSelected, selectedItems: selectedItems, toggleExpand: toggleExpand, parentId: parentId, toggleSelectGroup: toggleSelectGroup, onToggleSelectItem: onToggleSelectItem } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const [isHoverCardVisible, setIsHoverCardVisible] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== selectedItems || $[1] !== suggestions) {
        let t2;
        if ($[3] !== selectedItems) {
            t2 = (suggestion)=>selectedItems.has(suggestion.id);
            $[3] = selectedItems;
            $[4] = t2;
        } else t2 = $[4];
        t1 = suggestions.filter(t2);
        $[0] = selectedItems;
        $[1] = suggestions;
        $[2] = t1;
    } else t1 = $[2];
    const selectedSuggestionCount = t1.length;
    const t2 = isExpanded && $b84c4cb49dedd5e2$var$styles.groupCardExpanded;
    const t3 = isHoverCardVisible && $b84c4cb49dedd5e2$var$styles.groupCardHovering;
    let t4;
    if ($[5] !== t2 || $[6] !== t3) {
        t4 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.groupCard, t2, t3);
        $[5] = t2;
        $[6] = t3;
        $[7] = t4;
    } else t4 = $[7];
    const t5 = `review-content-suggestion-group-card-${parentId}`;
    const t6 = !isGroupSelected && $b84c4cb49dedd5e2$var$styles.unselectedOpacity;
    let t7;
    if ($[8] !== suggestions || $[9] !== toggleSelectGroup) {
        t7 = ()=>toggleSelectGroup(suggestions);
        $[8] = suggestions;
        $[9] = toggleSelectGroup;
        $[10] = t7;
    } else t7 = $[10];
    const t8 = isGroupSelected ? $b84c4cb49dedd5e2$var$i18n.deselectGroup : $b84c4cb49dedd5e2$var$i18n.selectGroup;
    let t9;
    if ($[11] !== formatMessage || $[12] !== parentTitle || $[13] !== t8) {
        t9 = formatMessage(t8, {
            title: parentTitle
        });
        $[11] = formatMessage;
        $[12] = parentTitle;
        $[13] = t8;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== isGroupSelected || $[16] !== t7 || $[17] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5ff49e7a1b080355$export$7eb83caae4372066), {
            isSelected: isGroupSelected,
            onClick: t7,
            ariaLabel: t9
        });
        $[15] = isGroupSelected;
        $[16] = t7;
        $[17] = t9;
        $[18] = t10;
    } else t10 = $[18];
    let t11;
    if ($[19] !== parentId || $[20] !== toggleExpand) {
        t11 = ()=>toggleExpand(parentId);
        $[19] = parentId;
        $[20] = toggleExpand;
        $[21] = t11;
    } else t11 = $[21];
    const t12 = isExpanded ? $b84c4cb49dedd5e2$var$i18n.collapseGroup : $b84c4cb49dedd5e2$var$i18n.expandGroup;
    let t13;
    if ($[22] !== formatMessage || $[23] !== parentTitle || $[24] !== t12) {
        t13 = formatMessage(t12, {
            title: parentTitle
        });
        $[22] = formatMessage;
        $[23] = parentTitle;
        $[24] = t12;
        $[25] = t13;
    } else t13 = $[25];
    let t14;
    if ($[26] !== parentTitle) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.groupTitleWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium",
            maxLines: 1
        }, parentTitle));
        $[26] = parentTitle;
        $[27] = t14;
    } else t14 = $[27];
    let t15;
    if ($[28] !== selectedSuggestionCount) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, selectedSuggestionCount);
        $[28] = selectedSuggestionCount;
        $[29] = t15;
    } else t15 = $[29];
    let t16;
    if ($[30] !== isExpanded) {
        t16 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2AytZ))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ghftu))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        });
        $[30] = isExpanded;
        $[31] = t16;
    } else t16 = $[31];
    let t17;
    if ($[32] !== isExpanded || $[33] !== t11 || $[34] !== t13 || $[35] !== t14 || $[36] !== t15 || $[37] !== t16) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.expandButton,
            onClick: t11,
            "aria-expanded": isExpanded,
            "aria-label": t13
        }, t14, t15, t16);
        $[32] = isExpanded;
        $[33] = t11;
        $[34] = t13;
        $[35] = t14;
        $[36] = t15;
        $[37] = t16;
        $[38] = t17;
    } else t17 = $[38];
    let t18;
    if ($[39] !== t10 || $[40] !== t17 || $[41] !== t6) {
        t18 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: t6
        }, t10, t17);
        $[39] = t10;
        $[40] = t17;
        $[41] = t6;
        $[42] = t18;
    } else t18 = $[42];
    const t19 = isExpanded && $b84c4cb49dedd5e2$var$styles.itemsListOuterExpanded;
    let t20;
    if ($[43] !== t19) {
        t20 = (0, $1Whri.cx)($b84c4cb49dedd5e2$var$styles.itemsListOuter, t19);
        $[43] = t19;
        $[44] = t20;
    } else t20 = $[44];
    const t21 = !isExpanded;
    let t22;
    if ($[45] !== onToggleSelectItem || $[46] !== selectedItems || $[47] !== suggestions) {
        let t23;
        if ($[49] !== onToggleSelectItem || $[50] !== selectedItems) {
            t23 = (suggestion_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionItemRow, {
                    key: suggestion_0.id,
                    suggestion: suggestion_0,
                    isSelected: selectedItems.has(suggestion_0.id),
                    onToggleSelectItem: onToggleSelectItem,
                    onHoverCardVisibilityChange: setIsHoverCardVisible
                });
            $[49] = onToggleSelectItem;
            $[50] = selectedItems;
            $[51] = t23;
        } else t23 = $[51];
        t22 = suggestions.map(t23);
        $[45] = onToggleSelectItem;
        $[46] = selectedItems;
        $[47] = suggestions;
        $[48] = t22;
    } else t22 = $[48];
    let t23;
    if ($[52] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.itemsList
        }, t22);
        $[52] = t22;
        $[53] = t23;
    } else t23 = $[53];
    let t24;
    if ($[54] !== t20 || $[55] !== t21 || $[56] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t20,
            "aria-hidden": t21
        }, t23);
        $[54] = t20;
        $[55] = t21;
        $[56] = t23;
        $[57] = t24;
    } else t24 = $[57];
    let t25;
    if ($[58] !== t18 || $[59] !== t24 || $[60] !== t4 || $[61] !== t5) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: t4,
            testId: t5
        }, t18, t24);
        $[58] = t18;
        $[59] = t24;
        $[60] = t4;
        $[61] = t5;
        $[62] = t25;
    } else t25 = $[62];
    return t25;
};
const $b84c4cb49dedd5e2$var$ModalLeftPanel = (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { groupedSuggestionsWithTitles: groupedSuggestionsWithTitles, selectedItems: selectedItems, expandedGroups: expandedGroups, toggleExpand: toggleExpand, toggleSelectGroup: toggleSelectGroup, toggleSelectItem: toggleSelectItem } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== expandedGroups || $[1] !== formatMessage || $[2] !== groupedSuggestionsWithTitles || $[3] !== selectedItems || $[4] !== toggleExpand || $[5] !== toggleSelectGroup || $[6] !== toggleSelectItem) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, [
            ...groupedSuggestionsWithTitles.entries()
        ].map((t2)=>{
            const [parentId, t3] = t2;
            const { parentTitle: parentTitle, suggestions: groupSuggestions } = t3;
            const isGroupSelected = groupSuggestions.some((s)=>selectedItems.has(s.id));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$SuggestionGroupRow, {
                key: parentId,
                parentTitle: parentTitle || formatMessage($b84c4cb49dedd5e2$var$i18n.untitled),
                suggestions: groupSuggestions,
                isExpanded: expandedGroups.has(parentId),
                isGroupSelected: isGroupSelected,
                selectedItems: selectedItems,
                toggleExpand: toggleExpand,
                parentId: parentId,
                toggleSelectGroup: toggleSelectGroup,
                onToggleSelectItem: toggleSelectItem
            });
        }));
        $[0] = expandedGroups;
        $[1] = formatMessage;
        $[2] = groupedSuggestionsWithTitles;
        $[3] = selectedItems;
        $[4] = toggleExpand;
        $[5] = toggleSelectGroup;
        $[6] = toggleSelectItem;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
};
const $b84c4cb49dedd5e2$export$c9ce09b966ffa4f7 = (t0)=>{
    const $ = (0, $frIzR.c)(31);
    const { groups: groups, contentTypes: contentTypes, spaceKey: spaceKey, isLoadingSuggestions: t1, onClose: onClose, onSaveSuccess: onSaveSuccess } = t0;
    const isLoadingSuggestions = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { Modal: Modal } = (0, $lsxnT.useChoreographerAssets)();
    let t2;
    if ($[0] !== groups) {
        t2 = groups.flatMap($b84c4cb49dedd5e2$var$_temp4);
        $[0] = groups;
        $[1] = t2;
    } else t2 = $[1];
    const allSuggestions = t2;
    const [expandedGroups, setExpandedGroups] = (0, $42omo.useState)($b84c4cb49dedd5e2$var$_temp5);
    let t3;
    if ($[2] !== allSuggestions) {
        t3 = ()=>new Set(allSuggestions.map($b84c4cb49dedd5e2$var$_temp6));
        $[2] = allSuggestions;
        $[3] = t3;
    } else t3 = $[3];
    const [selectedItems, setSelectedItems] = (0, $42omo.useState)(t3);
    let t4;
    if ($[4] !== groups) {
        t4 = groups.map($b84c4cb49dedd5e2$var$_temp7);
        $[4] = groups;
        $[5] = t4;
    } else t4 = $[5];
    const parentIds = t4;
    const { titlesByContentId: titlesByContentId, isLoading: isLoadingTitles } = (0, $d765c8713688ab6e$export$7610585fadab893e)(parentIds);
    const { submitActions: submitActions } = (0, $3b31958c77e1b16d$export$c9239e53ef385494)(spaceKey);
    const isLoading = isLoadingSuggestions || isLoadingTitles;
    let t5;
    if ($[6] !== allSuggestions || $[7] !== onSaveSuccess || $[8] !== selectedItems || $[9] !== submitActions) {
        t5 = ()=>{
            submitActions(allSuggestions, selectedItems);
            onSaveSuccess();
            window.location.reload();
        };
        $[6] = allSuggestions;
        $[7] = onSaveSuccess;
        $[8] = selectedItems;
        $[9] = submitActions;
        $[10] = t5;
    } else t5 = $[10];
    const handleAdd = t5;
    let result;
    if ($[11] !== groups || $[12] !== titlesByContentId) {
        result = new Map();
        groups.forEach((group)=>{
            result.set(group.parentId, {
                parentTitle: titlesByContentId.get(String(group.parentId)) ?? "",
                suggestions: group.remoteObjects
            });
        });
        $[11] = groups;
        $[12] = titlesByContentId;
        $[13] = result;
    } else result = $[13];
    const groupedSuggestionsWithTitles = result;
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (parentId)=>{
            setExpandedGroups((prev)=>{
                const next = new Set(prev);
                if (next.has(parentId)) next.delete(parentId);
                else next.add(parentId);
                return next;
            });
        };
        $[14] = t6;
    } else t6 = $[14];
    const toggleExpand = t6;
    let t7;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = (itemId)=>{
            setSelectedItems((prev_0)=>{
                const next_0 = new Set(prev_0);
                if (next_0.has(itemId)) next_0.delete(itemId);
                else next_0.add(itemId);
                return next_0;
            });
        };
        $[15] = t7;
    } else t7 = $[15];
    const toggleSelectItem = t7;
    let t8;
    if ($[16] !== selectedItems) {
        t8 = (groupSuggestions)=>{
            const allSelected = groupSuggestions.every((s_0)=>selectedItems.has(s_0.id));
            setSelectedItems((prev_1)=>{
                const next_1 = new Set(prev_1);
                groupSuggestions.forEach((s_1)=>{
                    if (allSelected) next_1.delete(s_1.id);
                    else next_1.add(s_1.id);
                });
                return next_1;
            });
        };
        $[16] = selectedItems;
        $[17] = t8;
    } else t8 = $[17];
    const toggleSelectGroup = t8;
    let t9;
    if ($[18] !== contentTypes || $[19] !== expandedGroups || $[20] !== formatMessage || $[21] !== groupedSuggestionsWithTitles || $[22] !== handleAdd || $[23] !== isLoading || $[24] !== selectedItems || $[25] !== toggleSelectGroup) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1DHa6.default), null, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.loadingOverlay,
            testId: "review-content-suggestions-modal-loading"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "large",
            label: formatMessage($b84c4cb49dedd5e2$var$i18n.loading)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.layout
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.leftPanel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.stackedContentTypeIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            contentTypes: contentTypes,
            variant: "large"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cO1el.default), {
            size: "medium"
        }, formatMessage($b84c4cb49dedd5e2$var$i18n.bringTogetherTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            color: "color.text.subtle"
        }, formatMessage($b84c4cb49dedd5e2$var$i18n.bringTogetherDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.groupListScrollArea
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b84c4cb49dedd5e2$var$ModalLeftPanel, {
            groupedSuggestionsWithTitles: groupedSuggestionsWithTitles,
            selectedItems: selectedItems,
            expandedGroups: expandedGroups,
            toggleExpand: toggleExpand,
            toggleSelectGroup: toggleSelectGroup,
            toggleSelectItem: toggleSelectItem
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            justifyContent: "end",
            xcss: $b84c4cb49dedd5e2$var$styles.addButtonRow
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
            appearance: "primary",
            onClick: handleAdd,
            isDisabled: selectedItems.size === 0
        }, formatMessage($b84c4cb49dedd5e2$var$i18n.addItemsToSpace, {
            count: selectedItems.size
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.rightPanel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $b84c4cb49dedd5e2$var$styles.closeButtonWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9ot3w.default), {
            hasCloseButton: true
        })))));
        $[18] = contentTypes;
        $[19] = expandedGroups;
        $[20] = formatMessage;
        $[21] = groupedSuggestionsWithTitles;
        $[22] = handleAdd;
        $[23] = isLoading;
        $[24] = selectedItems;
        $[25] = toggleSelectGroup;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== Modal || $[28] !== onClose || $[29] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Modal, {
            onClose: onClose,
            width: "x-large"
        }, t9);
        $[27] = Modal;
        $[28] = onClose;
        $[29] = t9;
        $[30] = t10;
    } else t10 = $[30];
    return t10;
};
function $b84c4cb49dedd5e2$var$_temp() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $b84c4cb49dedd5e2$var$_temp2() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $b84c4cb49dedd5e2$var$_temp3() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jdPfT))), {
        label: ""
    });
}
function $b84c4cb49dedd5e2$var$_temp4(g) {
    return g.remoteObjects;
}
function $b84c4cb49dedd5e2$var$_temp5() {
    return new Set();
}
function $b84c4cb49dedd5e2$var$_temp6(s) {
    return s.id;
}
function $b84c4cb49dedd5e2$var$_temp7(g_0) {
    return String(g_0.parentId);
}








const $d3bfb9815ee47511$export$b1532bcf7c9b2548 = (spaceKey)=>{
    const [groups, setGroups] = (0, $42omo.useState)([]);
    const [isLoading, setIsLoading] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (!spaceKey) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        const fetchSuggestions = async ()=>{
            try {
                const response = await (0, $f7B1p.cfetch)(`/wiki/rest/internal/1.0/spaces/${spaceKey}/remote-objects/suggestions`, {
                    method: 'GET'
                });
                const data = await response.json();
                if (data.suggestions && data.suggestions.length > 0) setGroups(data.suggestions);
            } catch  {
            // Silently fail — card won't render if there are no suggestions
            } finally{
                setIsLoading(false);
            }
        };
        fetchSuggestions();
    }, [
        spaceKey
    ]);
    return {
        groups: groups,
        isLoading: isLoading
    };
};




const $e69b9564388a8a7c$var$PRODUCT_LABELS = {
    googleDocs: 'Google Docs',
    googleSheets: 'Google Sheets',
    googleSlides: 'Google Slides',
    googleDrive: 'Google Drive',
    loom: 'Loom',
    figma: 'Figma',
    slack: 'Slack',
    link: 'Link'
};
function $e69b9564388a8a7c$export$451fcc3902224a39(url) {
    const productInfo = (0, $090b31fb8b21ef86$export$51b10001420b4ba3).find((entry)=>url.includes(entry.pattern)) ?? (0, $090b31fb8b21ef86$export$9911254b1f812303);
    return {
        product: $e69b9564388a8a7c$var$PRODUCT_LABELS[productInfo.productKey],
        iconUrl: productInfo.iconUrl
    };
}
const $e69b9564388a8a7c$var$styles = {
    container: "_2rko1qi0 _1reo15vq _18m915vq _bfhki8nm _19pku2gc _irr3plhp",
    mainAction: "_zulpu2gc _1rjcu2gc _16jlkb7n _1e0c1txw _4cvr1h6o _bozgu2gc _bfhk1j28",
    iconsWrapper: "_1e0c1txw _4cvr1h6o _1o9zidpf",
    dismissButton: "_1yt41b66 _1e0c1txw _4cvr1h6o _1bah1h6o _bfhk1j28 _irr31j28"
};
const $e69b9564388a8a7c$var$i18n = (0, $cgtv4.defineMessages)({
    addContent: {
        id: "side-navigation.space-navigation.related-content.add-content",
        defaultMessage: "Add content from your apps"
    },
    dismiss: {
        id: "side-navigation.space-navigation.related-content.dismiss",
        defaultMessage: "Dismiss related content"
    }
});
const $e69b9564388a8a7c$export$8372b97ddec977cb = ()=>{
    const $ = (0, $frIzR.c)(32);
    const intl = (0, $8C5kA.default)();
    const [isVisible, setIsVisible] = (0, $42omo.useState)(true);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isPersonalSpace = (0, $1I9Gw.isPersonalSpace)(spaceKey);
    const { groups: groups, isLoading: isLoadingSuggestions } = (0, $d3bfb9815ee47511$export$b1532bcf7c9b2548)(spaceKey);
    let t0;
    if ($[0] !== groups) {
        t0 = Array.from(new Set(groups.flatMap($e69b9564388a8a7c$var$_temp).map($e69b9564388a8a7c$var$_temp2).filter($e69b9564388a8a7c$var$_temp3)));
        $[0] = groups;
        $[1] = t0;
    } else t0 = $[1];
    const contentTypes = t0;
    if (isPersonalSpace || !isVisible || groups.length === 0 && !isLoadingSuggestions) return null;
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>setIsModalOpen(true);
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== contentTypes) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.iconsWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c5ab38ff0f87742b$export$98526f0dffd4f41b), {
            contentTypes: contentTypes
        }));
        $[3] = contentTypes;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== intl) {
        t3 = intl.formatMessage($e69b9564388a8a7c$var$i18n.addContent);
        $[5] = intl;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            weight: "medium"
        }, t3);
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t2 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e69b9564388a8a7c$var$styles.mainAction,
            onClick: t1
        }, t2, t4);
        $[9] = t2;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>setIsVisible(false);
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== intl) {
        t7 = intl.formatMessage($e69b9564388a8a7c$var$i18n.dismiss);
        $[13] = intl;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: ""
        });
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== t7) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: $e69b9564388a8a7c$var$styles.dismissButton,
            onClick: t6,
            "aria-label": t7
        }, t8);
        $[16] = t7;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t5 || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
            xcss: $e69b9564388a8a7c$var$styles.container,
            testId: "space-navigation-related-content"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            alignItems: "center"
        }, t5, t9));
        $[18] = t5;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== contentTypes || $[22] !== groups || $[23] !== isLoadingSuggestions || $[24] !== isModalOpen || $[25] !== spaceKey) {
        t11 = isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b84c4cb49dedd5e2$export$c9ce09b966ffa4f7), {
            groups: groups,
            contentTypes: contentTypes,
            spaceKey: spaceKey,
            isLoadingSuggestions: isLoadingSuggestions,
            onClose: ()=>setIsModalOpen(false),
            onSaveSuccess: ()=>setIsModalOpen(false)
        });
        $[21] = contentTypes;
        $[22] = groups;
        $[23] = isLoadingSuggestions;
        $[24] = isModalOpen;
        $[25] = spaceKey;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, t11);
        $[27] = t11;
        $[28] = t12;
    } else t12 = $[28];
    let t13;
    if ($[29] !== t10 || $[30] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t12);
        $[29] = t10;
        $[30] = t12;
        $[31] = t13;
    } else t13 = $[31];
    return t13;
};
function $e69b9564388a8a7c$var$_temp(g) {
    return g.remoteObjects;
}
function $e69b9564388a8a7c$var$_temp2(s) {
    return $e69b9564388a8a7c$export$451fcc3902224a39(s.url).product;
}
function $e69b9564388a8a7c$var$_temp3(p) {
    return p && p !== "Link";
}



var $5s27v = parcelRequire("5s27v");
















var $1Zr9M = parcelRequire("1Zr9M");


var $6f0Oj = parcelRequire("6f0Oj");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");





var $3gadb = parcelRequire("3gadb");


var $jZM59 = parcelRequire("jZM59");


var $5izcQ = parcelRequire("5izcQ");


var $inPa6 = parcelRequire("inPa6");


var $9x2sR = parcelRequire("9x2sR");


var $bedQP = parcelRequire("bedQP");





var $hXDOc = parcelRequire("hXDOc");


var $1NBp8 = parcelRequire("1NBp8");


var $1ytiN = parcelRequire("1ytiN");


var $eWwvy = parcelRequire("eWwvy");


var $d1wmn = parcelRequire("d1wmn");


var $joey7 = parcelRequire("joey7");





var $dPJCf = parcelRequire("dPJCf");





var $1kHsc = parcelRequire("1kHsc");








var $jrref = parcelRequire("jrref");




var $k7Tf7 = parcelRequire("k7Tf7");

var $a90ar = parcelRequire("a90ar");

var $3chlW = parcelRequire("3chlW");

var $f1UQW = parcelRequire("f1UQW");

var $71521 = parcelRequire("71521");

var $aVS0S = parcelRequire("aVS0S");

var $2owmo = parcelRequire("2owmo");

var $eopLP = parcelRequire("eopLP");

var $aZQ5F = parcelRequire("aZQ5F");

var $bUJpY = parcelRequire("bUJpY");

var $fdtRy = parcelRequire("fdtRy");

var $fNcP1 = parcelRequire("fNcP1");

var $aG6kF = parcelRequire("aG6kF");


var $gj7hi = parcelRequire("gj7hi");


var $fT2ta = parcelRequire("fT2ta");





var $3SChL = parcelRequire("3SChL");


var $3Awqk = parcelRequire("3Awqk");


var $2AgON = parcelRequire("2AgON");


var $35Nok = parcelRequire("35Nok");

var $5ecc3f8934f85e59$exports = {};
$5ecc3f8934f85e59$exports = new URL("Spaces.5611c4bd.gif", import.meta.url).toString();


var $db1162a25db39e60$exports = {};
$db1162a25db39e60$exports = new URL("Spaces-dark.4ceec6cd.gif", import.meta.url).toString();


var $537a412b2964f6f0$exports = {};
$537a412b2964f6f0$exports = new URL("Spaces-placeholder.5b3f2999.png", import.meta.url).toString();


var $a4e38a378b5824d3$exports = {};
$a4e38a378b5824d3$exports = new URL("Spaces-placeholder-dark.1c1d1b34.png", import.meta.url).toString();


const $f37e6d818dab503c$var$STEP_ID = 'nth-user-orientation-editor-space-spotlight';
const $f37e6d818dab503c$export$febddff29c5b0caa = ({ children: children })=>{
    const { reset: reset, next: next, currentStep: currentStep, progress: progress, hasInteracted: hasInteracted, active: active } = (0, $3SChL.useTour)($f37e6d818dab503c$var$STEP_ID);
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const isVisible = currentStep === $f37e6d818dab503c$var$STEP_ID;
    const { PopoverContent: PopoverContent } = (0, $lsxnT.useChoreographerAssets)();
    const currentSrc = (0, $35Nok.usePreloadGif)({
        gif: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($5ecc3f8934f85e59$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($db1162a25db39e60$exports)))
        },
        placeholder: {
            light: (0, (/*@__PURE__*/$parcel$interopDefault($537a412b2964f6f0$exports))),
            dark: (0, (/*@__PURE__*/$parcel$interopDefault($a4e38a378b5824d3$exports)))
        },
        skip: !active
    });
    const { handleNext: handleNext, handleDismiss: handleDismiss } = (0, $2AgON.useSpotlightAnalytics)({
        spotlightId: $f37e6d818dab503c$var$STEP_ID,
        isVisible: isVisible,
        onNext: next,
        onDismiss: reset
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $k7Tf7.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a90ar.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $jrref.Hide), {
        below: "md"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(PopoverContent, {
        shouldDismissOnClickOutside: false,
        dismiss: handleDismiss,
        next: handleNext,
        placement: "right-end",
        offset: [
            0,
            24
        ],
        isVisible: isVisible,
        messageId: $f37e6d818dab503c$var$STEP_ID,
        messageType: hasInteracted ? 'transactional' : 'engagement'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
        entranceDirection: "left"
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $71521.SpotlightCard), {
            testId: $f37e6d818dab503c$var$STEP_ID
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aZQ5F.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUJpY.SpotlightHeadline), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).headline)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aVS0S.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2owmo.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fdtRy.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gj7hi.default), {
            src: currentSrc,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f1UQW.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), null, formatMessage((0, $3Awqk.editorSpaceSpotlight).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eopLP.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aG6kF.SpotlightStepCount), null, formatMessage((0, $3Awqk.spotlight).progress, progress)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3chlW.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fNcP1.SpotlightPrimaryAction), null, formatMessage((0, $3Awqk.spotlight).next))))))))));
};











var $gtD4K = parcelRequire("gtD4K");


var $euUgw = parcelRequire("euUgw");







var $dcJ7R = parcelRequire("dcJ7R");









var $eGUIL = parcelRequire("eGUIL");

const $39cc7021b1f9471a$export$c915848be66d4457 = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { showExCoMessaging: t1 } = t0;
    const showExCoMessaging = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { handleScrollToTop: handleScrollToTop } = (0, $eGUIL.useSideNavigation)();
    let t2;
    if ($[0] !== createAnalyticsEvent || $[1] !== handleScrollToTop) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "QuickAccess",
                    source: "spaceNavigation",
                    data: {
                        navigationLayer: "global",
                        navigationContainer: "sidebar",
                        navVersion: "4"
                    }
                }
            }).fire();
            handleScrollToTop();
        };
        $[0] = createAnalyticsEvent;
        $[1] = handleScrollToTop;
        $[2] = t2;
    } else t2 = $[2];
    const onClick = t2;
    const t3 = showExCoMessaging && $39cc7021b1f9471a$var$additionalOffset;
    let t4;
    if ($[3] !== t3) {
        t4 = [
            $39cc7021b1f9471a$var$pressableStyles,
            $39cc7021b1f9471a$var$stickyWrapper,
            t3
        ];
        $[3] = t3;
        $[4] = t4;
    } else t4 = $[4];
    let t5;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = {
            borderColor: "transparent"
        };
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euUgw))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            size: "small"
        });
        $[6] = t6;
    } else t6 = $[6];
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
            space: "space.050",
            alignInline: "center",
            alignBlock: "center"
        }, t6, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            align: "center",
            size: "small",
            color: "color.text.subtle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $39cc7021b1f9471a$var$i18n.scrollToTopButtonLabel)));
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== onClick || $[9] !== t4) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: t4,
            id: "scroll-to-top-button",
            onClick: onClick,
            style: t5
        }, t7);
        $[8] = onClick;
        $[9] = t4;
        $[10] = t8;
    } else t8 = $[10];
    let t9;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $39cc7021b1f9471a$var$offsetElement
        });
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    if ($[12] !== t8) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t8, t9);
        $[12] = t8;
        $[13] = t10;
    } else t10 = $[13];
    return t10;
};
const $39cc7021b1f9471a$var$offsetElement = (0, $ecnYn.xcss)({
    //this element keeps the spacing from he negative top margin tha hides the button
    height: '17px',
    width: `100%`,
    display: 'flex'
});
const $39cc7021b1f9471a$var$additionalOffset = (0, $ecnYn.xcss)({
    top: `76px`
});
const $39cc7021b1f9471a$var$stickyWrapper = (0, $ecnYn.xcss)({
    zIndex: 'card',
    // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
    display: 'flex',
    position: 'sticky',
    top: `62px`,
    // @ts-ignore not assignable to type 'MarginSpace | GlobalValue | undefined'
    marginTop: `-50px`,
    //this hides the button underneath the space header until the ser scrolls down
    marginLeft: `auto`,
    marginRight: 'auto'
});
const $39cc7021b1f9471a$var$pressableStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'elevation.surface',
    borderWidth: 'border.width',
    borderStyle: 'solid',
    borderRadius: 'radius.full',
    paddingInline: 'space.100',
    alignItems: 'center',
    justifyContent: 'center',
    width: '125px',
    height: '32px',
    flexShrink: '0',
    boxShadow: 'elevation.shadow.overlay',
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    },
    ':focus': {
        outline: 'color.border.focused'
    }
});
const $39cc7021b1f9471a$var$i18n = (0, $cgtv4.defineMessages)({
    scrollToTopButtonLabel: {
        id: "side-navigation.global.scroll-to-top.button.label",
        defaultMessage: "Back to top"
    }
});














var $9VJDA = parcelRequire("9VJDA");


var $4kfV4 = parcelRequire("4kfV4");


var $1qfLF = parcelRequire("1qfLF");


var $lGgRw = parcelRequire("lGgRw");





var $bQm3c = parcelRequire("bQm3c");








const $476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8HXE5",
    name: "LazySpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("kjUXm"))).SpaceMoreActionsMenuContent
});

const $476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZCfkL",
    name: "LazyRestrictedSpaceMoreActionsMenuContent",
    loader: async ()=>(await (parcelRequire("kjUXm"))).RestrictedSpaceMoreActionsMenuContent
});
const $476e0e4b3e7f33df$export$cd488ab2b367186 = (props)=>{
    const $ = (0, $frIzR.c)(20);
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== props) {
        t0 = ()=>{
            props.setIsOpen(!props.isOpen);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: "spaceMoreActionsMenu",
                    source: "spaceNavigation",
                    attributes: {
                        navigationLayer: "container",
                        navigationContainer: "sidebar",
                        navVersion: "4",
                        componentType: "fixedItemButton",
                        itemId: "meatballDropdown",
                        isSpaceAdmin: props.isSpaceAdmin
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    const onClick = t0;
    let t1;
    if ($[3] !== createAnalyticsEvent || $[4] !== props) {
        t1 = (selection)=>(e)=>{
                e.stopPropagation();
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "button",
                        actionSubjectId: "spaceMoreActionsMenuItem",
                        source: "spaceMoreActionsMenu",
                        attributes: {
                            navigationLayer: "container",
                            navigationContainer: "sidebar",
                            navVersion: "4",
                            componentType: "fixedItemAction",
                            itemId: selection,
                            isSpaceAdmin: props.isSpaceAdmin
                        }
                    }
                }).fire();
                props.setIsOpen(false);
            };
        $[3] = createAnalyticsEvent;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    const onMenuItemClicked = t1;
    let t2;
    if ($[6] !== props) {
        t2 = ()=>props.setIsOpen(false);
        $[6] = props;
        $[7] = t2;
    } else t2 = $[7];
    let t3;
    if ($[8] !== isLoggedIn || $[9] !== onMenuItemClicked || $[10] !== props) {
        t3 = ()=>isLoggedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$LazySpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($476e0e4b3e7f33df$var$LazyRestrictedSpaceMoreActionsMenuContent, {
                ...props,
                onMenuItemClicked: onMenuItemClicked
            });
        $[8] = isLoggedIn;
        $[9] = onMenuItemClicked;
        $[10] = props;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onClick || $[13] !== props) {
        t4 = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...triggerProps,
                icon: $476e0e4b3e7f33df$var$_temp,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $476e0e4b3e7f33df$var$i18n.moreActions),
                onClick: onClick,
                spacing: "compact",
                appearance: "subtle",
                isSelected: props.isOpen
            }), (0, $6mKj3.expValEquals)("cc_editor_hide_blanket", "isEnabled", true) ? props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "space-more-actions-menu-blanket",
                isTinted: false,
                shouldAllowClickThrough: !props.isOpen,
                onBlanketClicked: ()=>props.setIsOpen(false)
            }) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4kfV4.default), {
                testId: "space-more-actions-menu-blanket",
                isTinted: false,
                shouldAllowClickThrough: !props.isOpen,
                onBlanketClicked: ()=>props.setIsOpen(false)
            }));
        $[12] = onClick;
        $[13] = props;
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== props.isOpen || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
            isOpen: props.isOpen,
            onClose: t2,
            content: t3,
            trigger: t4,
            placement: "right-start"
        });
        $[15] = props.isOpen;
        $[16] = t2;
        $[17] = t3;
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    return t5;
};
const $476e0e4b3e7f33df$var$i18n = (0, $cgtv4.defineMessages)({
    moreActions: {
        id: "side-navigation.space-navigation.more-actions",
        defaultMessage: "More actions"
    }
});
function $476e0e4b3e7f33df$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
        ...iconProps,
        size: "small"
    });
}



const $6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "6-_i-",
    loader: async ()=>(await (parcelRequire("gYqak"))).ExternalCollaboratorsSpaceInformationMessage,
    name: 'ExternalCollaboratorsSpaceInformationMessage'
});
const $6f43a2e4204022e9$var$RemovedSpotlightTarget = (0, $bedQP.componentWithFG)('remove_unused_spotlight_targets', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children), ({ name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5izcQ.default), {
        name: name
    }, children));
const $6f43a2e4204022e9$export$533fb76256978163 = (t0)=>{
    const $ = (0, $frIzR.c)(20);
    let containsExternalCollaborators;
    let isExternalCollaborator;
    let props;
    if ($[0] !== t0) {
        ({ isExternalCollaborator: isExternalCollaborator, containsExternalCollaborators: containsExternalCollaborators, ...props } = t0);
        $[0] = t0;
        $[1] = containsExternalCollaborators;
        $[2] = isExternalCollaborator;
        $[3] = props;
    } else {
        containsExternalCollaborators = $[1];
        isExternalCollaborator = $[2];
        props = $[3];
    }
    const [showExCoOnboardingNudge, setShowExCoOnboardingNudge] = (0, $42omo.useState)(false);
    const [onboardingStep, setOnboardingStep] = (0, $42omo.useState)(0);
    const { isLeftSidebarCollapsed: isLeftSidebarCollapsed } = (0, $jZM59.usePageLayoutResize)();
    const { isNewUser: isNewUser } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const showExCoMessaging = !isExternalCollaborator && containsExternalCollaborators;
    const showExCoModalOnboarding = !isNewUser && showExCoMessaging;
    const showExCoSpotlightOnboarding = !isNewUser && showExCoMessaging && showExCoOnboardingNudge && !isLeftSidebarCollapsed;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setShowExCoOnboardingNudge(true);
            setOnboardingStep(1);
        };
        $[4] = t1;
    } else t1 = $[4];
    const onGuestListOnboardingModalShown = t1;
    let t2;
    if ($[5] !== props || $[6] !== showExCoMessaging) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderInner, {
            ...props,
            showExCoMessaging: showExCoMessaging
        });
        $[5] = props;
        $[6] = showExCoMessaging;
        $[7] = t2;
    } else t2 = $[7];
    const header = t2;
    let t3;
    if ($[8] !== header || $[9] !== onboardingStep || $[10] !== showExCoSpotlightOnboarding) {
        t3 = showExCoSpotlightOnboarding && onboardingStep === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderExCoOnboarding, {
            header: header,
            onClose: ()=>setShowExCoOnboardingNudge(false)
        }) : header;
        $[8] = header;
        $[9] = onboardingStep;
        $[10] = showExCoSpotlightOnboarding;
        $[11] = t3;
    } else t3 = $[11];
    let t4;
    if ($[12] !== onboardingStep || $[13] !== props || $[14] !== showExCoModalOnboarding) {
        t4 = showExCoModalOnboarding && onboardingStep === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $d1wmn.ExternalCollaboratorInSpaceNotify), {
            onModalClose: onGuestListOnboardingModalShown,
            spaceKey: props.spaceKey
        });
        $[12] = onboardingStep;
        $[13] = props;
        $[14] = showExCoModalOnboarding;
        $[15] = t4;
    } else t4 = $[15];
    let t5;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $joey7.GuestOnboardingModalLoadable), null);
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== t3 || $[18] !== t4) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3, t4, t5);
        $[17] = t3;
        $[18] = t4;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
const $6f43a2e4204022e9$var$SpaceHeaderInner = (t0)=>{
    const $ = (0, $frIzR.c)(43);
    const { spaceId: spaceId, spaceName: spaceName, spaceKey: spaceKey, homepageId: homepageId, iconPath: iconPath, isStarred: isStarred, isWatched: isWatched, isSpaceAdmin: isSpaceAdmin, canManageSomeUsers: canManageSomeUsers, isPersonalSpace: isPersonalSpace, showExCoMessaging: showExCoMessaging, isSpaceArchived: isSpaceArchived, hasDeleteSpacePermission: hasDeleteSpacePermission, hasArchiveSpacePermission: hasArchiveSpacePermission } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isSelected = (0, $dPJCf.useRouteName)($6f43a2e4204022e9$var$isOnSpaceRouteArgs);
    let t1;
    if ($[0] !== homepageId || $[1] !== spaceKey) {
        t1 = (0, $1NBp8.SPACE_OVERVIEW).toUrl({
            spaceKey: spaceKey
        }, homepageId ? {
            query: {
                [(0, $1NBp8.SPACE_OVERVIEW).HOMEPAGE_ID_QUERY_KEY]: homepageId
            }
        } : undefined);
        $[0] = homepageId;
        $[1] = spaceKey;
        $[2] = t1;
    } else t1 = $[2];
    const spaceOverviewHref = t1;
    let t2;
    if ($[3] !== showExCoMessaging || $[4] !== spaceKey) {
        t2 = showExCoMessaging ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
            weight: "medium"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$ExternalCollaboratorsSpaceInformationMessageLoader, {
            analyticsSource: "spaceHeader",
            messageType: "IN_SPACE",
            shouldShowMessageIcon: false,
            shouldShowAdditionalMessageContext: false,
            spaceKey: spaceKey,
            isSubtle: true
        })) : undefined;
        $[3] = showExCoMessaging;
        $[4] = spaceKey;
        $[5] = t2;
    } else t2 = $[5];
    const description = t2;
    let t3;
    if ($[6] !== createAnalyticsEvent) {
        t3 = ()=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "spaceHeader",
                    source: "sideNavigation",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[6] = createAnalyticsEvent;
        $[7] = t3;
    } else t3 = $[7];
    const onClick = t3;
    const [isMoreActionsOpen, setIsMoreActionsOpen] = (0, $42omo.useState)(false);
    let t4;
    if ($[8] !== canManageSomeUsers || $[9] !== hasArchiveSpacePermission || $[10] !== hasDeleteSpacePermission || $[11] !== isMoreActionsOpen || $[12] !== isSpaceAdmin || $[13] !== isSpaceArchived || $[14] !== isStarred || $[15] !== isWatched || $[16] !== spaceId || $[17] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $476e0e4b3e7f33df$export$cd488ab2b367186), {
            isOpen: isMoreActionsOpen,
            setIsOpen: setIsMoreActionsOpen,
            spaceId: spaceId,
            spaceKey: spaceKey,
            isStarred: isStarred,
            isWatched: isWatched,
            isSpaceAdmin: isSpaceAdmin,
            canManageSomeUsers: canManageSomeUsers,
            isSpaceArchived: isSpaceArchived,
            hasDeleteSpacePermission: hasDeleteSpacePermission,
            hasArchiveSpacePermission: hasArchiveSpacePermission
        });
        $[8] = canManageSomeUsers;
        $[9] = hasArchiveSpacePermission;
        $[10] = hasDeleteSpacePermission;
        $[11] = isMoreActionsOpen;
        $[12] = isSpaceAdmin;
        $[13] = isSpaceArchived;
        $[14] = isStarred;
        $[15] = isWatched;
        $[16] = spaceId;
        $[17] = spaceKey;
        $[18] = t4;
    } else t4 = $[18];
    const moreActionsMenu = t4;
    let t5;
    if ($[19] !== iconPath || $[20] !== isPersonalSpace || $[21] !== isSpaceAdmin || $[22] !== spaceKey) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$EditableSpaceIcon, {
            spaceKey: spaceKey,
            iconPath: iconPath,
            isSpaceAdmin: isSpaceAdmin,
            isPersonalSpace: isPersonalSpace
        });
        $[19] = iconPath;
        $[20] = isPersonalSpace;
        $[21] = isSpaceAdmin;
        $[22] = spaceKey;
        $[23] = t5;
    } else t5 = $[23];
    let t6;
    if ($[24] !== description || $[25] !== isSelected || $[26] !== moreActionsMenu || $[27] !== onClick || $[28] !== spaceName || $[29] !== spaceOverviewHref || $[30] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9x2sR.LinkMenuItem), {
            href: spaceOverviewHref,
            isSelected: isSelected,
            onClick: onClick,
            elemBefore: t5,
            actions: moreActionsMenu,
            description: description
        }, spaceName);
        $[24] = description;
        $[25] = isSelected;
        $[26] = moreActionsMenu;
        $[27] = onClick;
        $[28] = spaceName;
        $[29] = spaceOverviewHref;
        $[30] = t5;
        $[31] = t6;
    } else t6 = $[31];
    let t7;
    if ($[32] !== spaceOverviewHref || $[33] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$stickyWrapper,
            "data-vc": "Nav4-space-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$SpaceHeaderContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f37e6d818dab503c$export$febddff29c5b0caa), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($6f43a2e4204022e9$var$RemovedSpotlightTarget, {
            name: "nav4-spotlight-2"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hXDOc.HoverPreloader), {
            name: "space-header",
            preloadUrl: spaceOverviewHref,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJSAndCriticalData
        }, t6)))));
        $[32] = spaceOverviewHref;
        $[33] = t6;
        $[34] = t7;
    } else t7 = $[34];
    let t8;
    if ($[35] !== showExCoMessaging) {
        t8 = !(0, $9wGTI.fg)("platform_dst_nav4_fhs_feedback_1") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            id: "space-header-bottom-divider",
            "data-vc": "space-header-bottom-divider-nav4",
            className: (0, $gMc0m.default)([
                "_195gxmi2 _n7zlia51 _kqsw1if8 _154i4bvh _1pbykb7n",
                showExCoMessaging && "_154it9kd"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": "space-header-bottom-divider-cloak-nav4",
            className: (0, $gMc0m.default)([
                "_n7zlc4nj _kqswstnw _1bsbq7sw _154i4bvh _1ltvxmi2 _1pbycs5v",
                showExCoMessaging && "_154it9kd"
            ])
        }));
        $[35] = showExCoMessaging;
        $[36] = t8;
    } else t8 = $[36];
    let t9;
    if ($[37] !== showExCoMessaging) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $39cc7021b1f9471a$export$c915848be66d4457), {
            showExCoMessaging: showExCoMessaging
        });
        $[37] = showExCoMessaging;
        $[38] = t9;
    } else t9 = $[38];
    let t10;
    if ($[39] !== t7 || $[40] !== t8 || $[41] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t7, t8, t9);
        $[39] = t7;
        $[40] = t8;
        $[41] = t9;
        $[42] = t10;
    } else t10 = $[42];
    return t10;
};
const $6f43a2e4204022e9$var$EditableSpaceIcon = (t0)=>{
    const $ = (0, $frIzR.c)(28);
    const { spaceKey: spaceKey, iconPath: iconPath, isSpaceAdmin: isSpaceAdmin, isPersonalSpace: isPersonalSpace } = t0;
    const intl = (0, $8C5kA.default)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { leftSidebarState: leftSidebarState, expandLeftSidebar: expandLeftSidebar } = (0, $jZM59.usePageLayoutResize)();
    const [isDialogOpen, setIsDialogOpen] = (0, $42omo.useState)(false);
    const [shouldRenderDialog, setShouldRenderDialog] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== iconPath) {
        t1 = iconPath ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            src: iconPath,
            alt: "",
            "data-testid": "space-icon",
            "data-vc": "space-header-icon-image",
            "data-ssr-placeholder-ignored": true,
            role: "presentation",
            className: (0, $gMc0m.default)([
                "_2rko1qi0 _1bsb1tcg _4t3i1tcg"
            ])
        }) : null;
        $[0] = iconPath;
        $[1] = t1;
    } else t1 = $[1];
    const image = t1;
    const canEdit = isSpaceAdmin && !isPersonalSpace;
    if (!canEdit) return image;
    let t2;
    if ($[2] !== intl) {
        t2 = intl.formatMessage($6f43a2e4204022e9$var$i18n.editSpaceDetails);
        $[2] = intl;
        $[3] = t2;
    } else t2 = $[3];
    const editLabel = t2;
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== expandLeftSidebar || $[6] !== experienceTracker || $[7] !== leftSidebarState.isFlyoutOpen) {
        t3 = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            experienceTracker.start({
                name: (0, $irVI7.EDIT_SPACE_LOGO_DETAILS_LOAD_EXPERIENCE),
                timeout: 10000
            });
            setShouldRenderDialog(true);
            setIsDialogOpen(true);
            if (leftSidebarState.isFlyoutOpen) expandLeftSidebar();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "editSpaceDetails",
                    source: "sideNavSpaceHeader",
                    attributes: {
                        navVersion: 4
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = expandLeftSidebar;
        $[6] = experienceTracker;
        $[7] = leftSidebarState.isFlyoutOpen;
        $[8] = t3;
    } else t3 = $[8];
    const onClick = t3;
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setShouldRenderDialog(true);
        };
        $[9] = t4;
    } else t4 = $[9];
    const onFocus = t4;
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setShouldRenderDialog(true);
        };
        $[10] = t5;
    } else t5 = $[10];
    const onMouseEnter = t5;
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>{
            setIsDialogOpen(true);
        };
        $[11] = t6;
    } else t6 = $[11];
    const onDialogOpen = t6;
    let t7;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = ()=>{
            setIsDialogOpen(false);
        };
        $[12] = t7;
    } else t7 = $[12];
    const onDialogClose = t7;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $6f43a2e4204022e9$var$editIconWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Zr9M))), {
            label: "",
            color: "var(--ds-icon-inverse, #FFFFFF)"
        }));
        $[13] = t8;
    } else t8 = $[13];
    let t9;
    if ($[14] !== editLabel || $[15] !== image || $[16] !== onClick) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2W0qg.default), {
            xcss: (0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? $6f43a2e4204022e9$var$iconButton : $6f43a2e4204022e9$var$iconButtonFallback,
            "aria-label": editLabel,
            onClick: onClick,
            onFocus: onFocus,
            onMouseEnter: onMouseEnter
        }, image, t8);
        $[14] = editLabel;
        $[15] = image;
        $[16] = onClick;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== editLabel || $[19] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
            content: editLabel
        }, t9);
        $[18] = editLabel;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== isDialogOpen || $[22] !== shouldRenderDialog || $[23] !== spaceKey) {
        t11 = shouldRenderDialog && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eWwvy.EditSpaceLogo), {
            spaceKey: spaceKey,
            isOpen: isDialogOpen,
            onOpen: onDialogOpen,
            onClose: onDialogClose
        });
        $[21] = isDialogOpen;
        $[22] = shouldRenderDialog;
        $[23] = spaceKey;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== t10 || $[26] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t10, t11);
        $[25] = t10;
        $[26] = t11;
        $[27] = t12;
    } else t12 = $[27];
    return t12;
};
const $6f43a2e4204022e9$var$isOnSpaceRouteArgs = {
    selector: (routeName)=>routeName === (0, $1NBp8.SPACE_INDEX).name || routeName === (0, $1NBp8.SPACE_OVERVIEW).name
};
const $6f43a2e4204022e9$var$additionalOffset = null;
const $6f43a2e4204022e9$var$stickyBorderCoverNav4 = null;
const $6f43a2e4204022e9$var$stickyWrapper = (0, $ecnYn.xcss)({
    position: 'sticky',
    top: 'space.0',
    zIndex: 'navigation' // Needs to be at least z-index 2 to appear on top of Content and Shortcuts
});
const $6f43a2e4204022e9$var$icon = null;
const $6f43a2e4204022e9$var$iconButton = (0, $ecnYn.xcss)({
    border: "var(--ds-space-0, 0px)",
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$iconButtonFallback = (0, $ecnYn.xcss)({
    border: 'none',
    borderRadius: 'radius.small',
    background: 'none',
    padding: 'space.0',
    position: 'relative',
    width: '24px',
    height: '24px',
    cursor: 'pointer',
    marginTop: 'space.050'
});
const $6f43a2e4204022e9$var$editIconWrapper = (0, $ecnYn.xcss)({
    position: 'absolute',
    height: '24px',
    width: '24px',
    top: 'space.0',
    left: 'space.0',
    padding: 'space.050',
    opacity: 0,
    transition: 'opacity 0.5s ease',
    ':hover': {
        opacity: 1
    },
    ':focus': {
        opacity: 1
    },
    backgroundColor: 'color.blanket',
    borderRadius: 'radius.medium'
});
const $6f43a2e4204022e9$var$stickyBorder = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6f43a2e4204022e9$var$SpaceHeaderContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_ca0qutpp _n3td1skh _bfhkvuon",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});

const $6f43a2e4204022e9$var$SpaceHeaderExCoOnboarding = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "QrIC5",
    name: "SpaceHeaderExCoOnboarding",
    loader: async ()=>(await (parcelRequire("jAO76"))).SpaceHeaderExCoOnboarding
});
const $6f43a2e4204022e9$var$i18n = (0, $cgtv4.defineMessages)({
    editSpaceDetails: {
        id: "side-navigation.space-navigation.header.edit-space-details",
        defaultMessage: "Edit space details"
    }
});



var $ENihE = parcelRequire("ENihE");











var $euL71 = parcelRequire("euL71");














var $28oQf = parcelRequire("28oQf");

const $078c23c8ca6acb4f$export$5ff3b51f9b84be4d = /*#__PURE__*/ (0, $42omo.memo)((t0)=>{
    const $ = (0, $frIzR.c)(15);
    const { links: links } = t0;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremiumEdition = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== isPremiumEdition || $[2] !== routeDataRef) {
        t1 = (itemId)=>()=>{
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "navigationItem",
                        actionSubjectId: "spaceNavigationItem",
                        source: "containerNavigation",
                        attributes: {
                            navigationLayer: "container",
                            itemId: itemId,
                            selectedItemPageContext: routeDataRef.current?.routeName,
                            navVersion: "4",
                            isPremiumEdition: isPremiumEdition
                        }
                    }
                }).fire();
            };
        $[0] = createAnalyticsEvent;
        $[1] = isPremiumEdition;
        $[2] = routeDataRef;
        $[3] = t1;
    } else t1 = $[3];
    const sendItemClickedAnalytics = t1;
    let t2;
    if ($[4] !== sendItemClickedAnalytics) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$CalendarsLink, {
            key: "calendars-link",
            onClick: sendItemClickedAnalytics("calendars")
        });
        $[4] = sendItemClickedAnalytics;
        $[5] = t2;
    } else t2 = $[5];
    let t3;
    if ($[6] !== sendItemClickedAnalytics) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
            key: "questions-link",
            onClick: sendItemClickedAnalytics("questions"),
            isLegacy: true
        });
        $[6] = sendItemClickedAnalytics;
        $[7] = t3;
    } else t3 = $[7];
    let t4;
    if ($[8] !== links || $[9] !== sendItemClickedAnalytics || $[10] !== t2 || $[11] !== t3) {
        const builtInitemsMapping = {
            [(0, $28oQf.CALENDARS_KEY)]: t2,
            [(0, $28oQf.QUESTIONS_KEY)]: t3,
            ...(0, $9wGTI.fg)("cc_editions_cq_native") && {
                [(0, $28oQf.QUESTIONS_NATIVE_KEY)]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($078c23c8ca6acb4f$var$QuestionsLink, {
                    key: "questions-native-link",
                    onClick: sendItemClickedAnalytics("questions")
                })
            }
        };
        t4 = links.filter($078c23c8ca6acb4f$var$_temp).sort($078c23c8ca6acb4f$var$_temp2).map((t5)=>{
            const { webItemCompleteKey: webItemCompleteKey } = t5;
            return webItemCompleteKey && builtInitemsMapping[webItemCompleteKey] || null;
        });
        $[8] = links;
        $[9] = sendItemClickedAnalytics;
        $[10] = t2;
        $[11] = t3;
        $[12] = t4;
    } else t4 = $[12];
    const renderedLinks = t4;
    let t5;
    if ($[13] !== renderedLinks) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderedLinks);
        $[13] = renderedLinks;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
});

const $078c23c8ca6acb4f$var$CalendarsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HaydR",
    name: "CalendarsLink",
    loader: async ()=>(await (parcelRequire("eBq5a"))).CalendarsLink
});

const $078c23c8ca6acb4f$var$QuestionsLink = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "8uaMN",
    name: "QuestionsLink",
    loader: async ()=>(await (parcelRequire("8Ai3e"))).QuestionsLink
});
function $078c23c8ca6acb4f$var$_temp(link) {
    return Boolean(link && !link.hidden);
}
function $078c23c8ca6acb4f$var$_temp2(a, b) {
    return Number(a.position) - Number(b.position);
}



var $aWrnw = parcelRequire("aWrnw");


const $c83507daffd5a949$var$ErrorView = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "NxOnG",
    name: "ErrorView",
    loader: async ()=>(await (parcelRequire("4vXZ9"))).ErrorView
});

const $c83507daffd5a949$var$SpaceApps = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MuuSQ",
    name: "SpaceApps",
    loader: async ()=>(await (parcelRequire("5rGiF"))).SpaceApps
});
const $c83507daffd5a949$var$spaceLinksStyles = null;
const $c83507daffd5a949$var$SidebarContent = /*#__PURE__*/ (0, $42omo.memo)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_n3tdze3t _kqswh2mm _19pk1wug",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}));
const $c83507daffd5a949$var$separatorStyles = null;
const $c83507daffd5a949$var$separatorStylesFallback = null;
const $c83507daffd5a949$export$ec7f7d400376dc53 = (t0)=>{
    const $ = (0, $frIzR.c)(49);
    const { navigationProps: navigationProps, errorProps: errorProps, spaceDetails: spaceDetails } = t0;
    const { loading: loading, hasSpace: hasSpace, space: space, spaceKey: spaceKey, homepageId: homepageId, main: main, quick: quick, isSpaceAdmin: isSpaceAdmin, isBlogNavigation: isBlogNavigation, blogsHidden: blogsHidden, pageTreeFinishedLoading: pageTreeFinishedLoading, onDragDropSuccess: onDragDropSuccess, showShortcutsSection: showShortcutsSection, shouldRenderSpaceApps: shouldRenderSpaceApps, allAppLinks: allAppLinks, allVisibleAppLinks: allVisibleAppLinks, loadingForgeApps: loadingForgeApps, onContentTreeLoadComplete: onContentTreeLoadComplete } = navigationProps;
    const { unhandledError: unhandledError, hasRestrictedError: hasRestrictedError, hasNotFoundError: hasNotFoundError, anonymousAccessQueryError: anonymousAccessQueryError } = errorProps;
    const isNav4Enabled = (0, $gz8ZY.useIsNav4Enabled)();
    if (unhandledError || hasRestrictedError || hasNotFoundError || anonymousAccessQueryError || !loading && !hasSpace) {
        const t1 = unhandledError || anonymousAccessQueryError;
        let t2;
        if ($[0] !== hasNotFoundError || $[1] !== hasRestrictedError || $[2] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$ErrorView, {
                unhandledError: t1,
                hasRestrictedError: hasRestrictedError,
                hasNotFoundError: hasNotFoundError
            });
            $[0] = hasNotFoundError;
            $[1] = hasRestrictedError;
            $[2] = t1;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    let t1;
    if ($[4] !== spaceDetails) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f43a2e4204022e9$export$533fb76256978163), spaceDetails);
        $[4] = spaceDetails;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $6mKj3.expValEquals)("confluence_autonomous_space_curation", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e69b9564388a8a7c$export$8372b97ddec977cb), null);
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== loading) {
        t3 = !loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_CONTAINER_EXPERIENCE)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[7] = loading;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== blogsHidden || $[10] !== homepageId || $[11] !== isBlogNavigation || $[12] !== isSpaceAdmin || $[13] !== loading || $[14] !== onContentTreeLoadComplete || $[15] !== onDragDropSuccess || $[16] !== pageTreeFinishedLoading || $[17] !== quick || $[18] !== showShortcutsSection || $[19] !== space || $[20] !== spaceKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5s27v.CommonSpaceNavigationContent), {
            showShortcutsSection: showShortcutsSection,
            space: space,
            spaceKey: spaceKey,
            quick: quick,
            homepageId: homepageId,
            loading: loading,
            isSpaceAdmin: isSpaceAdmin,
            isBlogNavigation: isBlogNavigation,
            blogsHidden: blogsHidden,
            pageTreeFinishedLoading: pageTreeFinishedLoading,
            onDragDropSuccess: onDragDropSuccess,
            onContentTreeLoadComplete: onContentTreeLoadComplete
        });
        $[9] = blogsHidden;
        $[10] = homepageId;
        $[11] = isBlogNavigation;
        $[12] = isSpaceAdmin;
        $[13] = loading;
        $[14] = onContentTreeLoadComplete;
        $[15] = onDragDropSuccess;
        $[16] = pageTreeFinishedLoading;
        $[17] = quick;
        $[18] = showShortcutsSection;
        $[19] = space;
        $[20] = spaceKey;
        $[21] = t4;
    } else t4 = $[21];
    let t5;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $gMc0m.default)([
            "_18s8ze3t _1yt4ze3t _qtt8glyw _vjgoze3t"
        ]);
        $[22] = t5;
    } else t5 = $[22];
    let t6;
    if ($[23] !== loading || $[24] !== main) {
        t6 = loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ENihE.ContainerSkeleton), {
            header: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $078c23c8ca6acb4f$export$5ff3b51f9b84be4d), {
            links: main
        });
        $[23] = loading;
        $[24] = main;
        $[25] = t6;
    } else t6 = $[25];
    let t7;
    if ($[26] !== t5 || $[27] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("ul", {
            "data-testid": "space-links",
            className: t5
        }, t6);
        $[26] = t5;
        $[27] = t6;
        $[28] = t7;
    } else t7 = $[28];
    let t8;
    if ($[29] !== allAppLinks || $[30] !== allVisibleAppLinks || $[31] !== isSpaceAdmin || $[32] !== loading || $[33] !== loadingForgeApps || $[34] !== shouldRenderSpaceApps || $[35] !== spaceKey) {
        t8 = !loading && !loadingForgeApps && shouldRenderSpaceApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $io723.PageSegmentLoadStart), {
            metric: (0, $aWrnw.SPACE_APPS_METRIC)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SpaceApps, {
            spaceKey: spaceKey,
            isSpaceAdmin: isSpaceAdmin,
            allAppLinks: allAppLinks,
            allVisibleAppLinks: allVisibleAppLinks
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null);
        $[29] = allAppLinks;
        $[30] = allVisibleAppLinks;
        $[31] = isSpaceAdmin;
        $[32] = loading;
        $[33] = loadingForgeApps;
        $[34] = shouldRenderSpaceApps;
        $[35] = spaceKey;
        $[36] = t8;
    } else t8 = $[36];
    let t9;
    if ($[37] !== t3 || $[38] !== t4 || $[39] !== t7 || $[40] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($c83507daffd5a949$var$SidebarContent, {
            "data-vc": "space-navigation-sidebar-content"
        }, t3, t4, t7, t8);
        $[37] = t3;
        $[38] = t4;
        $[39] = t7;
        $[40] = t8;
        $[41] = t9;
    } else t9 = $[41];
    let t10;
    if ($[42] !== isNav4Enabled || $[43] !== loading) {
        t10 = isNav4Enabled && !loading && (0, $9wGTI.fg)("nav4_global_links_confluence") && ((0, $9wGTI.fg)("confluence_frontend_tokenize_border") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itze3t _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("hr", {
            role: "presentation",
            id: "space-header-top-divider",
            className: (0, $gMc0m.default)([
                "_19itidpf _195gxmi2 _n7zlia51 _19pkutpp"
            ])
        }));
        $[42] = isNav4Enabled;
        $[43] = loading;
        $[44] = t10;
    } else t10 = $[44];
    let t11;
    if ($[45] !== t1 || $[46] !== t10 || $[47] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t1, t2, t9, t10);
        $[45] = t1;
        $[46] = t10;
        $[47] = t9;
        $[48] = t11;
    } else t11 = $[48];
    return t11;
};
module.exports["SpaceNavigationContent"] = $c83507daffd5a949$export$ec7f7d400376dc53;

});

parcelRegister("1I9Gw", function(module, exports) {
const $f0a04d35c062874d$export$1598149f6f3f7d46 = (spaceKey)=>{
    return spaceKey?.[0] === '~';
};
module.exports["isPersonalSpace"] = $f0a04d35c062874d$export$1598149f6f3f7d46;

});

parcelRegister("7aA9P", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");

class $538583af869725c3$export$b170112dc71045f1 extends (0, $42omo.PureComponent) {
    render() {
        const props = Object.assign({}, this.props);
        if ((this.state.error || !props.src) && props.fallback) {
            if (typeof props.fallback === 'string') props.src = props.fallback;
            else if (typeof props.fallback === 'function') return props.fallback();
        }
        delete props.fallback;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("img", {
            ...props,
            alt: props.alt || '',
            onError: this.onError
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            error: false
        };
        this.onError = ()=>{
            this.setState({
                error: true
            });
        };
    }
}
$538583af869725c3$export$b170112dc71045f1.propTypes = {
    fallback: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
    ])
};
module.exports["FallbackableImage"] = $538583af869725c3$export$b170112dc71045f1;

});

parcelRegister("lsxnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $i3jcY = parcelRequire("i3jcY");


var $cryCi = parcelRequire("cryCi");


var $3KdFR = parcelRequire("3KdFR");

const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $42omo.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    const plugin = ctx?.plugin;
    const isDisplayed = Boolean(plugin?.state?.isDisplayingMessage);
    (0, $42omo.useEffect)(()=>{
        window.__PO_ASSET_DISPLAYED__ = window.__PO_ASSET_DISPLAYED__ || isDisplayed;
    }, [
        isDisplayed
    ]);
    // Stubbed context monkey-patches the original context to prevent Choreographer components
    // from being rendered, to avoid random impact on performance and UI stability tests.
    // This is ONLY intended to use with E2E/playwright/Criterion tests loading Confluence
    // with `?stableUI=1` URL parameter.
    const stubbedContext = (0, $42omo.useMemo)(()=>({
            ...ctx,
            ...(0, $3KdFR.choreographerContextStub)
        }), [
        ctx
    ]);
    return (0, $i3jcY.isStableUIEnabledForTests)() ? stubbedContext : ctx;
};
module.exports["useChoreographerAssets"] = $be0f158b0b06806d$export$20bf42c8a29d776a;

});

parcelRegister("i3jcY", function(module, exports) {

var $4VJDS = parcelRequire("4VJDS");


const $47902e6ccb9229f6$var$STABLE_UI_PARAM = 'stableUI=1';
const $47902e6ccb9229f6$export$c0b9078f666b1acf = ()=>{
    if ((0, $4VJDS.default).isKillSwitchOn('cc_e2e_stable_ui')) // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    return window.location.search.includes($47902e6ccb9229f6$var$STABLE_UI_PARAM);
    return false;
};
module.exports["isStableUIEnabledForTests"] = $47902e6ccb9229f6$export$c0b9078f666b1acf;

});

parcelRegister("3KdFR", function(module, exports) {
const $d24b02c281555a47$var$ChoreographerComponentStub = ()=>{
    return null;
};
const $d24b02c281555a47$var$withChoreographerStub = ()=>{
    return ()=>null;
};
const $d24b02c281555a47$export$62522e606ba73c28 = {
    AutoDismissFlag: $d24b02c281555a47$var$ChoreographerComponentStub,
    Banner: $d24b02c281555a47$var$ChoreographerComponentStub,
    Flag: $d24b02c281555a47$var$ChoreographerComponentStub,
    InlineDialog: $d24b02c281555a47$var$ChoreographerComponentStub,
    Modal: $d24b02c281555a47$var$ChoreographerComponentStub,
    PopoverContent: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popper: $d24b02c281555a47$var$ChoreographerComponentStub,
    Popup: $d24b02c281555a47$var$ChoreographerComponentStub,
    Spotlight: $d24b02c281555a47$var$ChoreographerComponentStub,
    SpotlightCard: $d24b02c281555a47$var$ChoreographerComponentStub,
    withChoreographedRender: $d24b02c281555a47$var$withChoreographerStub,
    withChoreographedToggle: $d24b02c281555a47$var$withChoreographerStub
};
module.exports["choreographerContextStub"] = $d24b02c281555a47$export$62522e606ba73c28;

});

parcelRegister("jZM59", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");

const $e6220385bdb59eee$var$leftSidebarState = {
    isFlyoutOpen: false,
    isResizing: false,
    isLeftSidebarCollapsed: false,
    leftSidebarWidth: 0,
    lastLeftSidebarWidth: 0,
    flyoutLockCount: 0,
    isFixed: true,
    hasInit: false
};
const $e6220385bdb59eee$export$aa5a712eea4c2ae8 = /*#__PURE__*/ (0, $42omo.createContext)({
    isLeftSidebarCollapsed: false,
    expandLeftSidebar: (0, $ee7An.default),
    collapseLeftSidebar: (0, $ee7An.default),
    leftSidebarState: $e6220385bdb59eee$var$leftSidebarState,
    setLeftSidebarState: (0, $ee7An.default),
    toggleLeftSidebar: (0, $ee7An.default)
});
const $e6220385bdb59eee$export$10c7104037a7af62 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState, ...context } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    return context;
};
const $e6220385bdb59eee$export$94561f6055639ef7 = ()=>{
    const { setLeftSidebarState: setLeftSidebarState } = (0, $42omo.useContext)($e6220385bdb59eee$export$aa5a712eea4c2ae8);
    (0, $42omo.useEffect)(()=>{
        setLeftSidebarState((current)=>({
                ...current,
                flyoutLockCount: current.flyoutLockCount + 1
            }));
        return ()=>{
            setLeftSidebarState((current)=>({
                    ...current,
                    flyoutLockCount: current.flyoutLockCount - 1
                }));
        };
    }, [
        setLeftSidebarState
    ]);
};
module.exports["usePageLayoutResize"] = $e6220385bdb59eee$export$10c7104037a7af62;
module.exports["useLeftSidebarFlyoutLock"] = $e6220385bdb59eee$export$94561f6055639ef7;

});

parcelRegister("5izcQ", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $QiYCb = parcelRequire("QiYCb");


var $6cnUO = parcelRequire("6cnUO");

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 * - [Examples](https://atlassian.design/components/onboarding/examples)
 * - [Code](https://atlassian.design/components/onboarding/code)
 * - [Usage](https://atlassian.design/components/onboarding/usage)
 *
 * @deprecated Use `@atlaskit/spotlight` instead.
 */ const $f788f1551fff696f$var$SpotlightTarget = ({ children: children, name: name })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $6cnUO.TargetConsumer), {
        children: (getTargetRef)=>{
            if (typeof children === 'function') return children({
                targetRef: getTargetRef?.(name)
            });
            return getTargetRef ? /*#__PURE__*/ (0, $l998X.jsx)((0, $QiYCb.default), {
                name: name,
                hasNodeResolver: !(0, $dh538.fg)('platform_design_system_team_onboarding_noderesolve'),
                getTargetRef: getTargetRef,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                    children: children
                })
            }) : children;
        }
    });
$f788f1551fff696f$var$SpotlightTarget.displayName = 'SpotlightTarget';
var $f788f1551fff696f$export$2e2bcd8739ae039 = $f788f1551fff696f$var$SpotlightTarget;
module.exports["default"] = $f788f1551fff696f$export$2e2bcd8739ae039;

});

parcelRegister("QiYCb", function(module, exports) {
/* node-resolver-spotlight-target.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $e8Hkv = parcelRequire("e8Hkv");

const $9a3edd35791f2369$var$spanStyles = null; /**
                          * A wrapper component that conditionally applies a NodeResolver to its children.
                          *
                          * Note: NodeResolver should not be used in React 18 concurrent mode. This component
                          * is intended to be removed once the feature flag  is removed.
                          * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
                          * @param {ReactElement} props.children - The child elements to be wrapped.
                          * @param {string} props.name - The name to reference from Spotlight.
                          * @param {ReactElement} props.getTargetRef - Setting up Target Node in Spotlight Manager.
                          * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
                          */ 
const $9a3edd35791f2369$var$NodeResolverSpotlightTarget = ({ hasNodeResolver: hasNodeResolver, children: children, getTargetRef: getTargetRef, name: name })=>{
    const divRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        const targetRef = getTargetRef(name);
        if (!hasNodeResolver) targetRef(divRef.current?.firstElementChild);
        return ()=>{
            !hasNodeResolver && targetRef(undefined);
        };
    }, [
        hasNodeResolver,
        name,
        getTargetRef
    ]);
    if (hasNodeResolver) return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e8Hkv))), {
        innerRef: getTargetRef(name),
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ref: divRef,
        className: (0, $gMc0m.default)([
            "_1e0c1bgi"
        ]),
        children: children
    });
};
$9a3edd35791f2369$var$NodeResolverSpotlightTarget.displayName = 'NodeResolverSpotlightTarget';
var $9a3edd35791f2369$export$2e2bcd8739ae039 = $9a3edd35791f2369$var$NodeResolverSpotlightTarget;
module.exports["default"] = $9a3edd35791f2369$export$2e2bcd8739ae039;

});

parcelRegister("9x2sR", function(module, exports) {
/* link-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $eLJ8w = parcelRequire("eLJ8w");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");

const $a9268ffbf811ea39$var$listItemStyles = {
    root: "_10m98stt"
};
const $a9268ffbf811ea39$var$LinkMenuItemNoRef = ({ testId: testId, actions: actions, children: children, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, target: target, actionsOnHover: actionsOnHover, isSelected: isSelected, onClick: onClick, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, listItemRef: listItemRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const itemRef = (0, $42omo.useRef)(null);
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: isSelected ?? false
    });
    const ref = (0, $42omo.useMemo)(()=>{
        return (0, $3654r.default)([
            itemRef,
            listItemRef ?? null
        ]);
    }, [
        itemRef,
        listItemRef
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eLJ8w.ListItem), {
        ref: ref,
        xcss: $a9268ffbf811ea39$var$listItemStyles.root,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            testId: testId,
            description: description,
            actions: actions,
            elemAfter: elemAfter,
            // TODO Always use "open in new window" icon when `openInNewWindow` prop is true
            elemBefore: elemBefore,
            href: href,
            target: target,
            actionsOnHover: actionsOnHover,
            isSelected: isSelected,
            onClick: onClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
};
const $a9268ffbf811ea39$export$d2cad7a1cce7b35f = (0, $3hoG4.default)($a9268ffbf811ea39$var$LinkMenuItemNoRef);
module.exports["LinkMenuItem"] = $a9268ffbf811ea39$export$d2cad7a1cce7b35f;

});

parcelRegister("3hoG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $b38c95e6dd3d3e2d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

var /**
 * An alias for `forwardRef` with enhanced typing to preserve generic prop types.
 */ $b38c95e6dd3d3e2d$export$2e2bcd8739ae039 = (0, $42omo.forwardRef);

});

parcelRegister("fDC7w", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dRnqM = parcelRequire("dRnqM");


var $6BXcn = parcelRequire("6BXcn");

function $4023ab33a3161118$var$scrollMenuItemIntoView(element) {
    /**
	 * If [scrollIntoViewIfNeeded](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoViewIfNeeded) is available,
	 * we are using it to scroll the element into view _in the center_ of the scroll container. Because it is a non-standard method
	 * and not available on all browsers (currently not supported in Firefox), we are using it for progressive enhancement.
	 *
	 * Otherwise, we are falling back to [scrollIntoView](https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView).
	 */ const elementWithScrollMethod = element;
    if (typeof elementWithScrollMethod.scrollIntoViewIfNeeded === 'function') {
        elementWithScrollMethod.scrollIntoViewIfNeeded(true);
        return;
    }
    // JSDOM does not support scrollIntoView, so defensively using it (see https://github.com/jsdom/jsdom/issues/1695)
    element.scrollIntoView?.({
        // We are using `nearest` to prevent scrolling on user interaction when the menu item is already in view.
        block: 'nearest'
    });
}
function $4023ab33a3161118$export$2c52ec851fcc6058({ elementRef: elementRef, isSelected: isSelected }) {
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    const waitingStateRef = (0, $42omo.useRef)({
        type: 'waiting-to-be-selected-and-all-ancestors-expanded'
    });
    (0, $42omo.useEffect)(()=>{
        if (waitingStateRef.current.type === 'waiting-to-be-selected-and-all-ancestors-expanded') {
            const shouldScroll = areAllAncestorsExpanded && isSelected;
            if (!shouldScroll) return;
            const element = elementRef.current;
            (0, $dRnqM.default)(element, 'Element ref must be set');
            $4023ab33a3161118$var$scrollMenuItemIntoView(element);
            // Now that we are scrolled the menu item into view, we need to wait for the menu item to
            // be unselected before checking again.
            waitingStateRef.current.type = 'waiting-to-be-unselected';
            return;
        }
        if (waitingStateRef.current.type === 'waiting-to-be-unselected') {
            if (!isSelected) waitingStateRef.current.type = 'waiting-to-be-selected-and-all-ancestors-expanded';
            return;
        }
    }, [
        areAllAncestorsExpanded,
        elementRef,
        isSelected
    ]);
}
module.exports["useScrollMenuItemIntoView"] = $4023ab33a3161118$export$2c52ec851fcc6058;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("hXDOc", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");

var $b22e252a6b9677fd$export$3c7387d0e5ed624d = /*#__PURE__*/ function(PreloadingMode) {
    PreloadingMode["onlyJS"] = "onlyJS";
    PreloadingMode["onlyJSAndCriticalData"] = "onlyJSAndCriticalData";
    PreloadingMode["everything"] = "everything";
    return PreloadingMode;
}({});
const $b22e252a6b9677fd$var$PRELOAD_TIMER = 100;
const $b22e252a6b9677fd$var$sendAnalyticsEvent = (createAnalyticsEvent, action, name, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'hoverPreloader',
            actionSubjectId: name ?? 'n/a',
            source: 'hoverPreloader',
            attributes: attributes
        }
    }).fire();
};
const $b22e252a6b9677fd$var$preload = (preloadUrl, options = {})=>{
    window.dispatchEvent(new CustomEvent('preloadOnHover', {
        bubbles: true,
        detail: {
            preloadUrl: preloadUrl,
            ...options
        }
    }));
};
const $b22e252a6b9677fd$var$TransitionPreloaderImpl = ({ name: name, children: children, preloadUrl: preloadUrl, preloadOptions: preloadOptions })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const hoverTimeoutRef = (0, $42omo.useRef)(null);
    const preloadRef = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            preloadRef.current = false;
            if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        };
    }, []);
    // Here we implement multi-stage preloading. JS can be preloaded immediately and unconditionally.
    // For the rest of the preload options / experiments require at least a timeout, but other cases
    // may require more sophisticated logic to decide when or whether to preload.
    const onMouseEnter = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
        $b22e252a6b9677fd$var$preload(preloadUrl, {
            preloadingMode: "onlyJS"
        });
        // Do not proceed to the next stage if only JS preloading is enabled
        if (preloadOptions?.preloadingMode === "onlyJS") return;
        // Trigger next preloading stage either if everything is enabled or if critical data preloading
        // is enabled and the corresponding feature flag is enabled.
        const shouldPreload = preloadOptions?.preloadingMode === "everything" ? true : preloadOptions?.preloadingMode === "onlyJSAndCriticalData" && (0, $9wGTI.fg)('confluence_preload_critical_data');
        if (!shouldPreload) return;
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = window.setTimeout(()=>{
            $b22e252a6b9677fd$var$preload(preloadUrl, preloadOptions);
            preloadRef.current = true;
        }, $b22e252a6b9677fd$var$PRELOAD_TIMER);
    }, [
        preloadUrl,
        preloadOptions
    ]);
    const onMouseLeave = (0, $42omo.useCallback)(()=>{
        if (hoverTimeoutRef.current) window.clearTimeout(hoverTimeoutRef.current);
        if (preloadRef.current) $b22e252a6b9677fd$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', name, {
            preloadingMode: preloadOptions?.preloadingMode
        });
    }, [
        createAnalyticsEvent,
        name,
        preloadOptions?.preloadingMode
    ]);
    const onMouseDown = (0, $42omo.useCallback)(()=>{
        preloadRef.current = false;
    }, []);
    // Helper to chain child handlers with hover-preloader handlers
    const chain = (...fns)=>(...args)=>{
            fns.forEach((fn)=>{
                if (fn) fn(...args);
            });
        };
    const wrappedChild = /*#__PURE__*/ (0, $42omo.isValidElement)(children) ? /*#__PURE__*/ (0, $42omo.cloneElement)(children, {
        onMouseEnter: chain(children.props.onMouseEnter, onMouseEnter),
        onFocus: chain(children.props.onFocus, onMouseEnter),
        onMouseLeave: chain(children.props.onMouseLeave, onMouseLeave),
        onBlur: chain(children.props.onBlur, onMouseLeave),
        onMouseDown: chain(children.props.onMouseDown, onMouseDown)
    }) : children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        "data-vc": `hover-preloader-${name}`,
        "data-testid": "hover-preloader"
    }, wrappedChild);
};
const $b22e252a6b9677fd$export$16d0fec7f7c7ddfa = (props)=>{
    if (!props.preloadUrl) {
        if ((0, $6mKj3.expVal)('platform_editor_hydratable_ui', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-vc": `hover-preloader-${props.name}`,
            "data-testid": "hover-preloader"
        }, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, props.children);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b22e252a6b9677fd$var$TransitionPreloaderImpl, props);
};
const $b22e252a6b9677fd$export$f5ad7b1003f136b2 = {
    onlyJS: {
        preloadingMode: "onlyJS"
    },
    onlyJSAndCriticalData: {
        preloadingMode: "onlyJSAndCriticalData"
    },
    everything: {
        preloadingMode: "everything"
    }
};
module.exports["PreloadingMode"] = $b22e252a6b9677fd$export$3c7387d0e5ed624d;
module.exports["HoverPreloader"] = $b22e252a6b9677fd$export$16d0fec7f7c7ddfa;
module.exports["PreloadingPresets"] = $b22e252a6b9677fd$export$f5ad7b1003f136b2;

});

parcelRegister("eWwvy", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $49b80c0b2fd2c306$export$9c32b7bc3af8de64 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "5liJC",
    name: "EditSpaceLogo",
    loader: async ()=>(await (parcelRequire("fIdAJ"))).EditSpaceLogo
});
module.exports["EditSpaceLogo"] = $49b80c0b2fd2c306$export$9c32b7bc3af8de64;

});

parcelRegister("fIdAJ", function(module, exports) {

let $b7058211b83db610$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b7058211b83db610$var$load("kyxdN").then(()=>parcelRequire('asonV'));

});

parcelRegister("jrref", function(module, exports) {
/* hide.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $7ca6755ada461d2d$var$styles = {
    'above.xs': "_114bglyw",
    'above.sm': "_181nglyw",
    'above.md': "_dm25glyw",
    'above.lg': "_je3oglyw",
    'above.xl': "_1uxvglyw",
    'below.xs': "_1m0aglyw",
    'below.sm': "_sugaglyw",
    'below.md': "_1mjbglyw",
    'below.lg': "_liwcglyw",
    'below.xl': "_14wzglyw"
};
const $7ca6755ada461d2d$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(AsElement, {
        className: (0, $gMc0m.default)([
            above && $7ca6755ada461d2d$var$styles[`above.${above}`],
            below && $7ca6755ada461d2d$var$styles[`below.${below}`],
            xcss
        ]),
        children: children
    });
};
module.exports["Hide"] = $7ca6755ada461d2d$export$bed28288a051538;

});

parcelRegister("3SChL", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $751fcd22fac4dec6$export$7a357837346c6789 = {
    editor: [
        'nth-user-orientation-editor-space-spotlight',
        'nth-user-orientation-editor-for-you-spotlight',
        'nth-user-orientation-editor-bpqa-spotlight'
    ]
};
const $751fcd22fac4dec6$var$detectTour = (renderedSpotlights)=>{
    // Find the first tour where all required spotlights are registered
    for (const [tour, spotlights] of Object.entries($751fcd22fac4dec6$export$7a357837346c6789)){
        if (spotlights.every((spotlight)=>renderedSpotlights.has(spotlight))) return tour;
    }
    return null;
};
const $751fcd22fac4dec6$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        active: false,
        step: 0,
        renderedSpotlights: new Set(),
        hasInteracted: false
    },
    actions: {
        activate: ()=>({ setState: setState })=>{
                setState({
                    active: true,
                    step: 0
                });
            },
        reset: ()=>({ setState: setState })=>{
                setState({
                    active: false,
                    step: 0,
                    hasInteracted: false
                });
            },
        next: ()=>({ setState: setState, getState: getState })=>{
                const nextStep = Math.min(getState().step + 1, 2);
                setState({
                    step: nextStep,
                    hasInteracted: true
                });
            },
        back: ()=>({ setState: setState, getState: getState })=>{
                const prevStep = Math.max(getState().step - 1, 0);
                setState({
                    step: prevStep,
                    hasInteracted: true
                });
            },
        registerSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.add(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            },
        deregisterSpotlight: ({ spotlightId: spotlightId })=>({ setState: setState, getState: getState })=>{
                const newRegistered = new Set(getState().renderedSpotlights);
                newRegistered.delete(spotlightId);
                setState({
                    renderedSpotlights: newRegistered
                });
            }
    },
    name: 'experiment-nth-user-orientation-store'
});
const $751fcd22fac4dec6$export$6d3060c9729a9bf7 = (0, $9zUhf.createStateHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$31ec7099503725e8 = (0, $9zUhf.createActionsHook)($751fcd22fac4dec6$var$Store);
const $751fcd22fac4dec6$export$e9b94d8bc34db24 = (spotlightId)=>{
    const { next: next, back: back, reset: reset, registerSpotlight: registerSpotlight, deregisterSpotlight: deregisterSpotlight } = $751fcd22fac4dec6$export$31ec7099503725e8();
    const { step: step, active: active, renderedSpotlights: renderedSpotlights, hasInteracted: hasInteracted } = $751fcd22fac4dec6$export$6d3060c9729a9bf7();
    // Auto-register/deregister the spotlight when spotlights use this hook. This way
    // we can keep track of which spotlights are currently rendered, and use that list
    // to figure out if the user is eligible for a tour.
    (0, $42omo.useEffect)(()=>{
        registerSpotlight({
            spotlightId: spotlightId
        });
        return ()=>{
            deregisterSpotlight({
                spotlightId: spotlightId
            });
        };
    }, [
        spotlightId,
        registerSpotlight,
        deregisterSpotlight
    ]);
    const detectedTour = (0, $42omo.useMemo)(()=>$751fcd22fac4dec6$var$detectTour(renderedSpotlights), [
        renderedSpotlights
    ]);
    if (!active || !detectedTour) return {
        reset: reset,
        back: back,
        next: next,
        currentStep: null,
        progress: {
            step: 0,
            steps: 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
    return {
        reset: reset,
        back: back,
        next: next,
        currentStep: $751fcd22fac4dec6$export$7a357837346c6789[detectedTour][step],
        progress: {
            step: step + 1,
            steps: detectedTour ? $751fcd22fac4dec6$export$7a357837346c6789[detectedTour].length : 0
        },
        hasInteracted: hasInteracted,
        active: active
    };
};
module.exports["useNthUserOrientationState"] = $751fcd22fac4dec6$export$6d3060c9729a9bf7;
module.exports["useNthUserOrientationActions"] = $751fcd22fac4dec6$export$31ec7099503725e8;
module.exports["useTour"] = $751fcd22fac4dec6$export$e9b94d8bc34db24;

});

parcelRegister("3Awqk", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $90247d71b6534bef$export$ce22f6f6b0034afd = (0, $cgtv4.defineMessages)({
    next: {
        id: "experiment-nth-user-orientation.spotlight.next",
        defaultMessage: "Next"
    },
    back: {
        id: "experiment-nth-user-orientation.spotlight.back",
        defaultMessage: "Back"
    },
    done: {
        id: "experiment-nth-user-orientation.spotlight.done",
        defaultMessage: "Done"
    },
    dismiss: {
        id: "experiment-nth-user-orientation.spotlight.dismiss",
        defaultMessage: "Dismiss Tour"
    },
    progress: {
        id: "experiment-nth-user-orientation.spotlight.progress",
        defaultMessage: "{step} of {steps}"
    }
});
const $90247d71b6534bef$export$9a4454cd199ce080 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.headline",
        defaultMessage: "Your space, your start"
    },
    body: {
        id: "experiment-nth-user-orientation.editorSpaceSpotlight.body",
        defaultMessage: "This is your personal space. Create more to organize your team\u2019s work."
    }
});
const $90247d71b6534bef$export$252e22890fb2efa6 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.headline",
        defaultMessage: "Catch up on team activity here"
    },
    body: {
        id: "experiment-nth-user-orientation.editorForYouSpotlight.body",
        defaultMessage: "See recent pages, team updates, and quick links tailored for you."
    }
});
const $90247d71b6534bef$export$6794fada8079fe55 = (0, $cgtv4.defineMessages)({
    headline: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.headline",
        defaultMessage: "Now let\u2019s create your first page!"
    },
    body: {
        id: "experiment-nth-user-orientation.editorBpqaSpotlight.body",
        defaultMessage: "With a template, a page is a click away. Hover on one for a preview."
    }
});
module.exports["spotlight"] = $90247d71b6534bef$export$ce22f6f6b0034afd;
module.exports["editorSpaceSpotlight"] = $90247d71b6534bef$export$9a4454cd199ce080;
module.exports["editorForYouSpotlight"] = $90247d71b6534bef$export$252e22890fb2efa6;
module.exports["editorBpqaSpotlight"] = $90247d71b6534bef$export$6794fada8079fe55;

});

parcelRegister("2AgON", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS = {
    'nth-user-orientation-editor-space-spotlight': 'nthUserOrientationEditorSpaceSpotlight',
    'nth-user-orientation-editor-for-you-spotlight': 'nthUserOrientationEditorForYouSpotlight',
    'nth-user-orientation-editor-bpqa-spotlight': 'nthUserOrientationEditorBpqaSpotlight'
};
function $3c36b21fe0d55bcd$export$b54fada573f13a91({ spotlightId: spotlightId, isVisible: isVisible, onNext: onNext, onBack: onBack, onDismiss: onDismiss }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    // Fire render event when spotlight becomes visible
    (0, $42omo.useEffect)(()=>{
        if (isVisible) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'rendered',
                actionSubject: 'spotlight',
                actionSubjectId: $3c36b21fe0d55bcd$var$SPOTLIGHT_ACTION_SUBJECT_IDS[spotlightId],
                source: 'nth-user-orientation'
            }
        }).fire();
    }, [
        isVisible,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleNext = (0, $42omo.useCallback)(()=>{
        if (onNext) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'next',
                    source: spotlightId
                }
            }).fire();
            onNext();
        }
    }, [
        onNext,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleBack = (0, $42omo.useCallback)(()=>{
        if (onBack) {
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'back',
                    source: spotlightId
                }
            }).fire();
            onBack();
        }
    }, [
        onBack,
        createAnalyticsEvent,
        spotlightId
    ]);
    const handleDismiss = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'dismissTour',
                source: spotlightId
            }
        }).fire();
        onDismiss();
    }, [
        onDismiss,
        createAnalyticsEvent,
        spotlightId
    ]);
    return {
        handleNext: onNext ? handleNext : undefined,
        handleBack: onBack ? handleBack : undefined,
        handleDismiss: handleDismiss
    };
}
module.exports["useSpotlightAnalytics"] = $3c36b21fe0d55bcd$export$b54fada573f13a91;

});

parcelRegister("35Nok", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cOrQJ = parcelRequire("cOrQJ");

const $cd2e96a49affba4b$export$4b64aca38e15f2eb = ({ gif: gif, placeholder: placeholder, skip: skip = false })=>{
    const { colorMode: colorMode } = (0, $cOrQJ.default)();
    const gifSrc = gif[colorMode ?? 'light'];
    const placeholderSrc = placeholder[colorMode ?? 'light'];
    const [isReady, setIsReady] = (0, $42omo.useState)(false);
    (0, $42omo.useEffect)(()=>{
        if (skip) return;
        setIsReady(false);
        const image = new Image();
        image.onload = ()=>{
            setIsReady(true);
        };
        image.onerror = ()=>{
            setIsReady(false);
        };
        image.src = gifSrc;
        // If the image has already loaded (cached), handle it immediately
        if (image.complete) setIsReady(true);
    }, [
        gifSrc,
        skip
    ]);
    return isReady ? gifSrc : placeholderSrc;
};
module.exports["usePreloadGif"] = $cd2e96a49affba4b$export$4b64aca38e15f2eb;

});

parcelRegister("eGUIL", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $6ab3d9f83e467c30$export$8ff51aff18368071 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $6ab3d9f83e467c30$export$18d9743f01f9c283 = ()=>{
    const context = (0, $42omo.useContext)($6ab3d9f83e467c30$export$8ff51aff18368071);
    if (!context) throw new Error("useSideNavigation must be used within a SideNavigationContext.Provider");
    return context;
};
module.exports["SideNavigationContext"] = $6ab3d9f83e467c30$export$8ff51aff18368071;
module.exports["useSideNavigation"] = $6ab3d9f83e467c30$export$18d9743f01f9c283;

});

parcelRegister("kjUXm", function(module, exports) {

let $ecb1c35b6eebec09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ecb1c35b6eebec09$var$load("bg6Ss"),
    $ecb1c35b6eebec09$var$load("6wr18"),
    $ecb1c35b6eebec09$var$load("hHrTM"),
    $ecb1c35b6eebec09$var$load("8UKe0"),
    $ecb1c35b6eebec09$var$load("ffEVr"),
    $ecb1c35b6eebec09$var$load("7EorR"),
    $ecb1c35b6eebec09$var$load("fZt2F"),
    $ecb1c35b6eebec09$var$load("Wowvf"),
    $ecb1c35b6eebec09$var$load("PkFdp")
]).then(()=>parcelRequire('hSgLQ'));

});

parcelRegister("gYqak", function(module, exports) {

let $c5b68be5e678a3d5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c5b68be5e678a3d5$var$load("6oFhK").then(()=>parcelRequire('iwt54'));

});

parcelRegister("jAO76", function(module, exports) {

let $e4384098ddb383b3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e4384098ddb383b3$var$load("860dT").then(()=>parcelRequire('8KFPL'));

});

parcelRegister("28oQf", function(module, exports) {
const $a5e3205ff2d8ec91$export$38788381122702f5 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-space-analytics';
const $a5e3205ff2d8ec91$export$6c3d789a4f56bea2 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-addonengine-analytics-moderate-space-analytics';
const $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-automation';
const $a5e3205ff2d8ec91$export$dad26f289a3f773e = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-blogs';
const $a5e3205ff2d8ec91$export$27d01545acc1e1ca = 'com.atlassian.confluence.extra.team-calendars:space-calendar-sidebar-link';
const $a5e3205ff2d8ec91$export$a1081c7e806b45a0 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-k15t-orderly-databases-database';
const $a5e3205ff2d8ec91$export$de45ec31104af09 = 'com.atlassian.plugins.atlassian-connect-plugin:space-navigation-web-item-com-atlassian-confluence-plugins-confluence-questions-question';
const $a5e3205ff2d8ec91$export$1b86edccef2dd51 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-questions';
const $a5e3205ff2d8ec91$export$f618e448a4ddfafa = 'com.atlassian.confluence.plugins.confluence-frontend-support:space-tools-link';
const $a5e3205ff2d8ec91$export$9727611105a72ba4 = 'com.atlassian.plugins.atlassian-connect-plugin';
const $a5e3205ff2d8ec91$export$35d69df876e79a8b = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-shortcuts';
const $a5e3205ff2d8ec91$export$28596511f20e98f2 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-apps';
const $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6 = 'com.atlassian.confluence.plugins.confluence-space-ia:spacebar-content-manager';
module.exports["ANALYTICS_KEY"] = $a5e3205ff2d8ec91$export$38788381122702f5;
module.exports["ANALYTICS_KEY_MODERATE"] = $a5e3205ff2d8ec91$export$6c3d789a4f56bea2;
module.exports["AUTOMATION_KEY"] = $a5e3205ff2d8ec91$export$ee99bc1ad01a63ae;
module.exports["BLOG_KEY"] = $a5e3205ff2d8ec91$export$dad26f289a3f773e;
module.exports["CALENDARS_KEY"] = $a5e3205ff2d8ec91$export$27d01545acc1e1ca;
module.exports["DATABASES_KEY"] = $a5e3205ff2d8ec91$export$a1081c7e806b45a0;
module.exports["QUESTIONS_KEY"] = $a5e3205ff2d8ec91$export$de45ec31104af09;
module.exports["QUESTIONS_NATIVE_KEY"] = $a5e3205ff2d8ec91$export$1b86edccef2dd51;
module.exports["SPACE_SETTINGS_KEY"] = $a5e3205ff2d8ec91$export$f618e448a4ddfafa;
module.exports["CONNECT_ADDON_KEY"] = $a5e3205ff2d8ec91$export$9727611105a72ba4;
module.exports["SHORTCUTS_KEY"] = $a5e3205ff2d8ec91$export$35d69df876e79a8b;
module.exports["APPS_KEY"] = $a5e3205ff2d8ec91$export$28596511f20e98f2;
module.exports["BULK_TOOLS_KEY"] = $a5e3205ff2d8ec91$export$1c0f21b83a6a96d6;

});

parcelRegister("eBq5a", function(module, exports) {

let $aa18c0cad27925d9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $aa18c0cad27925d9$var$load("6wr18"),
    $aa18c0cad27925d9$var$load("ffEVr"),
    $aa18c0cad27925d9$var$load("c08ou")
]).then(()=>parcelRequire('99rcJ'));

});

parcelRegister("8Ai3e", function(module, exports) {

let $63ffb01b27107377$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63ffb01b27107377$var$load("6wr18"),
    $63ffb01b27107377$var$load("ffEVr"),
    $63ffb01b27107377$var$load("8uhuz")
]).then(()=>parcelRequire('ar6Ga'));

});

parcelRegister("4vXZ9", function(module, exports) {

let $34989688401e1317$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $34989688401e1317$var$load("6wr18"),
    $34989688401e1317$var$load("ffEVr"),
    $34989688401e1317$var$load("klGUa")
]).then(()=>parcelRequire('8o2bj'));

});

parcelRegister("5rGiF", function(module, exports) {

let $3f70494418328523$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3f70494418328523$var$load("6wr18"),
    $3f70494418328523$var$load("ffEVr"),
    $3f70494418328523$var$load("fZt2F"),
    $3f70494418328523$var$load("7EorR"),
    $3f70494418328523$var$load("kZjBp")
]).then(()=>parcelRequire('1xLOH'));

});

parcelRegister("6i41U", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $8x1Q3 = parcelRequire("8x1Q3");

/**
 * __useRouterLink()__
 *
 * Hook: Returns app-configured router link component.
 *
 * A generic can be passed to define advanced link configuration:
 * ```
 * type MyRouterLinkConfig = {
 *  to: string;
 *  replace?: boolean;
 * }
 *
 * const RouterLink = useRouterLink<MyRouterLinkConfig>();
 * ```
 */ const $77954d5459a690cb$var$useRouterLink = ()=>{
    const { routerLinkComponent: routerLinkComponent } = (0, $42omo.useContext)((0, $8x1Q3.RouterLinkProviderContext));
    if (routerLinkComponent) return routerLinkComponent;
    return;
};
var $77954d5459a690cb$export$2e2bcd8739ae039 = $77954d5459a690cb$var$useRouterLink;
module.exports["default"] = $77954d5459a690cb$export$2e2bcd8739ae039;

});

parcelRegister("8x1Q3", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

const $830764d8fffe9f5a$export$2931e0ee690eee88 = /*#__PURE__*/ (0, $42omo.createContext)({});
/**
 * __RouterLinkProvider__
 *
 * Provides a configured router link component for use
 * within Design System components.
 */ const $830764d8fffe9f5a$var$RouterLinkProvider = ({ routerLinkComponent: routerLinkComponent, children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($830764d8fffe9f5a$export$2931e0ee690eee88.Provider, {
        value: {
            routerLinkComponent: routerLinkComponent
        },
        children: children
    });
};
var $830764d8fffe9f5a$export$2e2bcd8739ae039 = $830764d8fffe9f5a$var$RouterLinkProvider;
module.exports["RouterLinkProviderContext"] = $830764d8fffe9f5a$export$2931e0ee690eee88;

});

parcelRegister("aJPUt", function(module, exports) {
var $bcb0fe1d423eb4f4$export$5e180a90f8d3e374 = /*#__PURE__*/ function(ExperienceTimeout) {
    ExperienceTimeout[ExperienceTimeout["DEFAULT"] = 60000] = "DEFAULT";
    ExperienceTimeout[ExperienceTimeout["CREATE_CONTENT"] = 30000] = "CREATE_CONTENT";
    ExperienceTimeout[ExperienceTimeout["CREATE_DIALOG_LOAD"] = 60000] = "CREATE_DIALOG_LOAD";
    ExperienceTimeout[ExperienceTimeout["MACRO_LOAD"] = 60000] = "MACRO_LOAD";
    ExperienceTimeout[ExperienceTimeout["CREATE_COMMENT_PUBLISH"] = 15000] = "CREATE_COMMENT_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["EDITOR_LOAD"] = 45000] = "EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["EDITOR_PUBLISH"] = 60000] = "EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["LIVE_PAGE_PUBLISH"] = 30000] = "LIVE_PAGE_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_LOAD"] = 90000] = "TEMPLATE_EDITOR_LOAD";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_EDITOR_PUBLISH"] = 60000] = "TEMPLATE_EDITOR_PUBLISH";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATE_PANEL_LOAD"] = 20000] = "IN_EDITOR_TEMPLATE_PANEL_LOAD";
    ExperienceTimeout[ExperienceTimeout["IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR"] = 90000] = "IN_EDITOR_TEMPLATES_UPDATE_CONTENT_REFRESH_EDITOR";
    ExperienceTimeout[ExperienceTimeout["HOME"] = 20000] = "HOME";
    ExperienceTimeout[ExperienceTimeout["NAVIGATION_LOAD"] = 30000] = "NAVIGATION_LOAD";
    ExperienceTimeout[ExperienceTimeout["PAGE_LOAD"] = 60000] = "PAGE_LOAD";
    ExperienceTimeout[ExperienceTimeout["SELECT_INLINE_COMMMENT"] = 30000] = "SELECT_INLINE_COMMMENT";
    ExperienceTimeout[ExperienceTimeout["VIEW_INLINE_COMMENT"] = 30000] = "VIEW_INLINE_COMMENT";
    ExperienceTimeout[ExperienceTimeout["SPACE_DIRECTORY"] = 60000] = "SPACE_DIRECTORY";
    ExperienceTimeout[ExperienceTimeout["SPACE_VIEWS"] = 20000] = "SPACE_VIEWS";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE"] = 20000] = "TEMPLATE_GALLERY_TEMPLATE_DETAIL_UPDATE";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_PREVIEW"] = 20000] = "TEMPLATE_PREVIEW";
    ExperienceTimeout[ExperienceTimeout["TEMPLATE_SUGGESTIONS"] = 20000] = "TEMPLATE_SUGGESTIONS";
    ExperienceTimeout[ExperienceTimeout["LOOM_PAGE_HEADER_CONTENT_INSERTION"] = 20000] = "LOOM_PAGE_HEADER_CONTENT_INSERTION";
    return ExperienceTimeout;
}({});
module.exports["ExperienceTimeout"] = $bcb0fe1d423eb4f4$export$5e180a90f8d3e374;

});

parcelRegister("3AeIf", function(module, exports) {
/**
 * @generated SignedSource<<656b0d44239f7eb3a8ba9659e9762f2f>>
 * @relayHash f18661cc7a1d2d55f19018b453d74e49
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62
const $ca580f7b974eac2e$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "concreteType": "UserPreferences",
            "kind": "LinkedField",
            "name": "userPreferences",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "spaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ScalarField",
                    "name": "spaceViewsPersistence"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f18661cc7a1d2d55f19018b453d74e49",
            "id": "5b9f82627568e61d5a48e4bdd045a30d7fc6ac7b992beec39feead5b18838e62",
            "metadata": {},
            "name": "useSpaceViewsOptionsPersistenceQuery",
            "operationKind": "query",
            "text": "query useSpaceViewsOptionsPersistenceQuery($spaceKey:String!){userPreferences{spaceViewsPersistence(spaceKey:$spaceKey)}}"
        }
    };
}();
$ca580f7b974eac2e$var$node.hash = "cc599626e8f53c4256f22a11dfce92c8";
var $ca580f7b974eac2e$export$2e2bcd8739ae039 = $ca580f7b974eac2e$var$node;
module.exports["default"] = $ca580f7b974eac2e$export$2e2bcd8739ae039;

});

parcelRegister("aJT7b", function(module, exports) {
/* list.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $002d225363d96747$var$_List({ children: children, testId: testId, xcss: xcss }, forwardedRef) {
    return(/**
     * We are using `role="list"` instead of a `ul` element to enable more flexible
     * composition. By using ARIA roles we can validly have elements between a list
     * and list items, as long as those in-between elements have no semantics.
     */ /*#__PURE__*/ (0, $l998X.jsx)("div", {
        role: "list",
        ref: forwardedRef,
        className: xcss,
        "data-testid": testId,
        children: children
    }));
}
const $002d225363d96747$export$54c2e3dc7acea9f5 = /*#__PURE__*/ (0, $42omo.forwardRef)($002d225363d96747$var$_List);
module.exports["List"] = $002d225363d96747$export$54c2e3dc7acea9f5;

});

parcelRegister("1CdLs", function(module, exports) {
/* expandable-menu-item.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6mkwk = parcelRequire("6mkwk");


var $jvL0g = parcelRequire("jvL0g");


var $6BXcn = parcelRequire("6BXcn");

const $417a895b4429e145$var$relativeStyles = {
    root: "_kqswh2mm"
}; /**
    * __ExpandableMenuItem__
    *
    * A composable component for nested menu items that can be revealed and hidden by interacting witih the parent menu item.
    *
    * Follows the [disclosure pattern](https://www.w3.org/WAI/ARIA/apg/patterns/disclosure/).
    *
    * Should be used with `ExpandableMenuItemTrigger` as the parent menu item, and children menu items should be wrapped in a `ExpandableMenuItemContent`.
    *
    * Usage example:
    * ```jsx
    * <ExpandableMenuItem>
    *   <ExpandableMenuItemTrigger>Parent menu item</ExpandableMenuItemTrigger>
    *   <ExpandableMenuItemContent>
    *     <ButtonMenuItem>Item 1</ButtonMenuItem>
    *     <ButtonMenuItem>Item 2</ButtonMenuItem>
    *   </ExpandableMenuItemContent>
    * </ExpandableMenuItem>
    * ```
    */ 
const $417a895b4429e145$export$341dea48c30b36ff = /*#__PURE__*/ (0, $42omo.forwardRef)(({ isExpanded: isExpandedControlled, isDefaultExpanded: isDefaultExpanded = false, onExpansionToggle: onExpansionToggle, children: children, dropIndicator: dropIndicator, testId: testId }, forwardedRef)=>{
    const [isExpanded, setIsExpanded] = (0, $6mkwk.default)(isExpandedControlled, ()=>isDefaultExpanded);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.IsExpandedContext).Provider, {
        value: isExpanded,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.SetIsExpandedContext).Provider, {
            value: setIsExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.OnExpansionToggleContext).Provider, {
                value: onExpansionToggle ?? null,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $jvL0g.MenuListItem), {
                    ref: forwardedRef,
                    testId: testId,
                    children: /*#__PURE__*/ (0, $l998X.jsxs)("div", {
                        className: (0, $gMc0m.default)([
                            dropIndicator && $417a895b4429e145$var$relativeStyles.root
                        ]),
                        children: [
                            children,
                            dropIndicator
                        ]
                    })
                })
            })
        })
    });
});
module.exports["ExpandableMenuItem"] = $417a895b4429e145$export$341dea48c30b36ff;

});

parcelRegister("YQCfa", function(module, exports) {
/* expandable-menu-item-content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $aJT7b = parcelRequire("aJT7b");


var $6BXcn = parcelRequire("6BXcn");

const $73667a40c01a69a2$var$styles = {
    content: "_bozg1crf",
    collapsedContent: "_1e0cglyw"
};
const $73667a40c01a69a2$export$bd680a81504a92e9 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children }, forwardedRef)=>{
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const level = (0, $6BXcn.useLevel)();
    const hasExpanded = (0, $42omo.useRef)(false);
    const areAllAncestorsExpanded = (0, $6BXcn.useAreAllAncestorsExpanded)();
    if (!isExpanded && !hasExpanded.current) return null;
    hasExpanded.current = true;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.LevelContext).Provider, {
        value: level + 1,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6BXcn.AreAllAncestorsExpandedContext).Provider, {
            value: /**
     * By combining the current ancestor and with the current menu item's state, all nested menu items will know if their
     * ancestor menu items are all expanded.
     */ areAllAncestorsExpanded && isExpanded,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $aJT7b.List), {
                ref: forwardedRef,
                xcss: (0, $1bHXt.cx)($73667a40c01a69a2$var$styles.content, !isExpanded && $73667a40c01a69a2$var$styles.collapsedContent),
                children: children
            })
        })
    });
});
module.exports["ExpandableMenuItemContent"] = $73667a40c01a69a2$export$bd680a81504a92e9;

});

parcelRegister("8INvs", function(module, exports) {
/* expandable-menu-item-trigger.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $3hoG4 = parcelRequire("3hoG4");


var $ghftu = parcelRequire("ghftu");


var $6R5uz = parcelRequire("6R5uz");


var $dh538 = parcelRequire("dh538");


var $8njHX = parcelRequire("8njHX");


var $fDC7w = parcelRequire("fDC7w");


var $6BXcn = parcelRequire("6BXcn");

const $675a107b26f743ab$var$chevronDisplayCssVar = '--expandable-chevron-display';
const $675a107b26f743ab$var$providedElemBeforeDisplayCssVar = '--expandable-provided-elembefore-display';
const $675a107b26f743ab$var$wrapperStyles = {
    root: "_1mmi1txw _165nglyw",
    showProvidedElemBefore: "_1mmiglyw _165n1bgi _v9u71txw _1hl9glyw _b31z1txw _1vnl1txw _12xsglyw _p8btglyw"
};
const $675a107b26f743ab$var$nestedOpenPopupStylesOld = {
    showProvidedElemBefore: "_v9u71txw _1hl9glyw"
}; // Merge back into the `wrapperStyles` after cleanup
const $675a107b26f743ab$var$nestedOpenPopupStylesNew = {
    showProvidedElemBefore: "_1ddp1txw _pnu5glyw"
};
const $675a107b26f743ab$var$iconStyles = {
    chevron: "_1e0ciw0t _1tz3r0mg",
    providedElemBefore: "_1e0c1xb2",
    providedElemBeforeSelected: "_syazxl6c"
};
const $675a107b26f743ab$var$ExpandableMenuItemIcon = ({ iconProps: iconProps, isExpanded: isExpanded, isSelected: isSelected, providedElemBefore: providedElemBefore })=>{
    const ChevronIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($ghftu))) : (0, (/*@__PURE__*/$parcel$interopDefault($6R5uz)));
    const chevronElem = /*#__PURE__*/ (0, $l998X.jsx)(ChevronIcon, {
        ...iconProps,
        label: "",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined,
        size: "small"
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.chevron
                ]),
                children: chevronElem
            }),
            providedElemBefore && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    $675a107b26f743ab$var$iconStyles.providedElemBefore,
                    isSelected && $675a107b26f743ab$var$iconStyles.providedElemBeforeSelected
                ]),
                children: providedElemBefore
            })
        ]
    });
};
const $675a107b26f743ab$export$fe6fe51056867f4d = (0, $3hoG4.default)(({ actions: actions, isSelected: isSelected, href: href, elemBefore: providedElemBefore, elemAfter: elemAfter, actionsOnHover: actionsOnHover, onClick: onClick, children: children, testId: testId, interactionName: interactionName, isContentTooltipDisabled: isContentTooltipDisabled, visualContentRef: visualContentRef, isDragging: isDragging, hasDragIndicator: hasDragIndicator, dropIndicator: dropIndicator }, forwardedRef)=>{
    const id = (0, $42omo.useId)();
    const onExpansionToggle = (0, $6BXcn.useOnExpansionToggle)();
    const isExpanded = (0, $6BXcn.useIsExpanded)();
    const setIsExpanded = (0, $6BXcn.useSetIsExpanded)();
    const itemRef = (0, $42omo.useRef)(null);
    const handleIconClick = (0, $42omo.useCallback)(()=>{
        onExpansionToggle?.(!isExpanded);
        setIsExpanded(!isExpanded);
    }, [
        isExpanded,
        onExpansionToggle,
        setIsExpanded
    ]);
    const handleMenuContentClick = (0, $42omo.useCallback)((event, analyticsEvent)=>{
        const newValue = !isExpanded;
        onClick?.(event, analyticsEvent, {
            isExpanded: newValue
        });
        onExpansionToggle?.(newValue);
        setIsExpanded(newValue);
    }, [
        onClick,
        onExpansionToggle,
        isExpanded,
        setIsExpanded
    ]);
    const isSelectable = typeof href !== 'undefined';
    (0, $fDC7w.useScrollMenuItemIntoView)({
        elementRef: itemRef,
        isSelected: Boolean(isSelectable && isSelected)
    }); // Wrapped in an IconButton if the expandable menu item trigger is selectable
    const elemBefore = isSelectable ? /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
                iconProps: iconProps,
                isExpanded: isExpanded,
                isSelected: isSelected,
                providedElemBefore: providedElemBefore
            }),
        "aria-expanded": isExpanded,
        // screen readers on what will actually be expanded or collapsed. Screen readers will also use the
        // `aria-expanded` attribute to indicate the expanded state of the menu item.
        // We are not using the `aria-label` attribute here as it is not supported by the `IconButton` component.
        "aria-labelledby": id,
        // `aria-labelledby`, which will be used instead.
        label: "",
        appearance: "subtle",
        spacing: "compact",
        onClick: handleIconClick,
        interactionName: interactionName,
        testId: testId ? `${testId}--elem-before-button` : undefined
    }) : /*#__PURE__*/ (0, $l998X.jsx)($675a107b26f743ab$var$ExpandableMenuItemIcon, {
        isExpanded: isExpanded,
        isSelected: isSelected,
        providedElemBefore: providedElemBefore
    }); // For expandable menu items, we shouldn't wrap in a `li` here. The `li` is instead at a higher level (`ExpandableMenuItem`), grouping the expandable menu item trigger and its content
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        ref: itemRef,
        className: (0, $gMc0m.default)([
            $675a107b26f743ab$var$wrapperStyles.root,
            providedElemBefore && $675a107b26f743ab$var$wrapperStyles.showProvidedElemBefore,
            (0, $dh538.fg)('platform_dst_nav4_flyout_menu_slots_close_button') ? $675a107b26f743ab$var$nestedOpenPopupStylesNew.showProvidedElemBefore : $675a107b26f743ab$var$nestedOpenPopupStylesOld.showProvidedElemBefore
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8njHX.MenuItemBase), {
            id: id,
            actions: actions,
            actionsOnHover: actionsOnHover,
            elemBefore: elemBefore,
            ariaExpanded: isExpanded,
            elemAfter: elemAfter,
            href: href,
            isSelected: isSelected,
            onClick: handleMenuContentClick,
            ref: forwardedRef,
            visualContentRef: visualContentRef,
            testId: testId,
            interactionName: interactionName,
            isContentTooltipDisabled: isContentTooltipDisabled,
            isDragging: isDragging,
            hasDragIndicator: hasDragIndicator,
            dropIndicator: dropIndicator,
            children: children
        })
    });
});
module.exports["ExpandableMenuItemTrigger"] = $675a107b26f743ab$export$fe6fe51056867f4d;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $xQxzY = parcelRequire("xQxzY");


var $6jrkJ = parcelRequire("6jrkJ");


var $kOBmw = parcelRequire("kOBmw");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $xQxzY.useQuery)((0, $kOBmw.IsSuperAdmin), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("kOBmw", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $1f121c69ed56862b$export$b43e9b817e671e28 = (0, $eSUdr.default)`query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id confluence{roles{isSuperAdmin}}}}`;
module.exports["IsSuperAdmin"] = $1f121c69ed56862b$export$b43e9b817e671e28;

});

parcelRegister("2vuKf", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");


var $bwL2u = parcelRequire("bwL2u");

const $d03c194add2856c2$export$214964e539560671 = (0, $9zUhf.createHook)((0, $bwL2u.Store), {
    selector: (state)=>state.multiSelectMode === (0, $bwL2u.MultiSelectMode).ACTIVE
});
module.exports["useIsMultiSelectActive"] = $d03c194add2856c2$export$214964e539560671;

});

parcelRegister("bwL2u", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

var $647b75406606f8a7$export$630aa3bad9698e43 = /*#__PURE__*/ function(MultiSelectMode) {
    MultiSelectMode["ACTIVE"] = "active";
    MultiSelectMode["INACTIVE"] = "inactive";
    MultiSelectMode["DISABLED"] = "disabled";
    return MultiSelectMode;
}({});
const $647b75406606f8a7$var$initialState = {
    multiSelectMode: "inactive",
    selectedContent: {},
    count: 0,
    loadingDescendantIds: new Set()
};
const $647b75406606f8a7$var$actions = {
    getState: ()=>({ getState: getState })=>{
            return getState();
        },
    enterMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "active",
                selectedContent: {},
                count: 0
            });
        },
    exitMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "inactive",
                selectedContent: {},
                count: 0
            });
        },
    disableMultiSelect: ()=>({ setState: setState })=>{
            setState({
                multiSelectMode: "disabled"
            });
        },
    getSelectedDescendantCount: (contentId)=>({ getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            return selectedContent[contentId].selectedDescendantCount;
        },
    updateTotalCount: (delta)=>({ getState: getState, setState: setState })=>{
            const { count: prevCount } = getState();
            setState({
                count: prevCount + delta
            });
        },
    // Update the selected descendant count.
    updateSelectedDescendantsCount: (contentId, descendantCount)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [contentId]: {
                    selectedDescendantCount: descendantCount,
                    deselectedChildren: selectedContent[contentId]?.deselectedChildren ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Update the parent content's deselected children array.
    updateParent: (contentId, parentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = {
                ...selectedContent,
                [parentId]: {
                    selectedDescendantCount: selectedContent[parentId].selectedDescendantCount,
                    deselectedChildren: new Set([
                        ...selectedContent[parentId].deselectedChildren
                    ].filter((x)=>x !== contentId)) ?? new Set()
                }
            };
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    selectNestedContent: (items)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            // First element in items is the current item being selected.
            const currentItemId = items[0].id;
            const newSelectedContent = {
                ...selectedContent
            };
            for (const item of items){
                if (currentItemId === item.id && item.parentId && item.parentId in newSelectedContent) newSelectedContent[item.parentId].deselectedChildren.delete(item.id);
                newSelectedContent[item.id] = {
                    selectedDescendantCount: 0,
                    deselectedChildren: selectedContent[item.id]?.deselectedChildren ?? new Set()
                };
            }
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Selects the content and its descendants, updating the selectedContent state.
    incrementAncestors: (ancestorIds, currentContentSelectionCount, countToRemove)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount + currentContentSelectionCount - countToRemove + 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Decrement the selected descendant count of ancestors when a content is deselected.
    decrementAncestors: (ancestorIds, currentContentId)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            const selectItemCount = selectedContent[currentContentId].selectedDescendantCount;
            const newSelectedContent = ancestorIds.reduce((acc, parentId)=>{
                if (parentId in acc) acc[parentId] = {
                    ...acc[parentId],
                    selectedDescendantCount: acc[parentId].selectedDescendantCount - selectItemCount - 1
                };
                return acc;
            }, {
                ...selectedContent
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    // Deselects the content and its descendants, updating the selectedContent state.
    deselectNestedContent: (contentIds, parentIds)=>({ setState: setState, getState: getState })=>{
            const { selectedContent: selectedContent } = getState();
            let newSelectedContent = {
                ...selectedContent
            };
            contentIds.forEach((contentId)=>{
                // Remove the contentId from selectedContent
                const { [contentId]: removed, ...rest } = newSelectedContent;
                newSelectedContent = rest;
                // For each parentId, update its deselectedChildren set
                parentIds.forEach((parentId)=>{
                    if (parentId in newSelectedContent) {
                        const parentContent = {
                            ...newSelectedContent[parentId]
                        };
                        if (!parentContent.deselectedChildren) parentContent.deselectedChildren = new Set();
                        parentContent.deselectedChildren.add(contentId);
                        newSelectedContent[parentId] = parentContent;
                    }
                });
            });
            setState({
                selectedContent: newSelectedContent
            });
        },
    clearSelection: ()=>({ setState: setState })=>{
            setState({
                selectedContent: {},
                count: 0
            });
        },
    addLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.add(contentId);
            setState({
                loadingDescendantIds: next
            });
        },
    removeLoadingDescendant: (contentId)=>({ setState: setState, getState: getState })=>{
            const next = new Set(getState().loadingDescendantIds);
            next.delete(contentId);
            setState({
                loadingDescendantIds: next
            });
        }
};
const $647b75406606f8a7$export$390f32400eaf98c9 = (0, $1P1Tu.createStore)({
    initialState: $647b75406606f8a7$var$initialState,
    actions: $647b75406606f8a7$var$actions,
    name: 'contentTreeSelection'
});
const $647b75406606f8a7$export$cbc26e3dcdb786e6 = (0, $9zUhf.createHook)($647b75406606f8a7$export$390f32400eaf98c9);
const $647b75406606f8a7$export$ce1c0cba22262219 = (0, $9zUhf.createActionsHook)($647b75406606f8a7$export$390f32400eaf98c9);
module.exports["MultiSelectMode"] = $647b75406606f8a7$export$630aa3bad9698e43;
module.exports["Store"] = $647b75406606f8a7$export$390f32400eaf98c9;
module.exports["useContentTreeSelection"] = $647b75406606f8a7$export$cbc26e3dcdb786e6;
module.exports["useContentTreeSelectionActions"] = $647b75406606f8a7$export$ce1c0cba22262219;

});

parcelRegister("3qtLb", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $jmjWc = parcelRequire("jmjWc");


var $4VJDS = parcelRequire("4VJDS");


var $5Abqh = parcelRequire("5Abqh");


var $6mKj3 = parcelRequire("6mKj3");

const $674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF = 'confluence_frontend_delay_hydration_on_hover';
const $674e09754a51af28$export$19ffb24f8071504 = 2;

const $674e09754a51af28$export$10d5dbd9dd81149f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-KKls",
    name: "PageTreeLoader",
    loader: async ()=>(await (parcelRequire("igNnM"))).PageTree
});

const $674e09754a51af28$export$8ce7795bff922b41 = (0, $jmjWc.LoadableHydrateOnHover)({
    __loadable_id__: "dXqjD",
    name: "PageTreeLoaderOnHover",
    loader: async ()=>(await (parcelRequire("igNnM"))).PageTree,
    hydrateImmediately: ()=>{
        // If page tree was not successfully rendered on server-side, hydrate immediately otherwise user will see a blank page tree
        return !(0, $5Abqh.checkSSRPartialSuccess)((0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree);
    }
});
const $674e09754a51af28$export$73500bf5f2e2b0c4 = (props)=>{
    const $ = (0, $frIzR.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $4VJDS.default).getNumber($674e09754a51af28$var$DELAY_HYRATION_ON_HOVER_FF, 0) || 0;
        $[0] = t0;
    } else t0 = $[0];
    const delayHydrationOnHoverTimeout = t0;
    let t1;
    if ($[1] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, !(0, $6mKj3.expVal)("confluence_frontend_remove_hydrateonhover_pagetree", "isEnabled", false) && delayHydrationOnHoverTimeout > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$8ce7795bff922b41, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($674e09754a51af28$export$10d5dbd9dd81149f, props));
        $[1] = props;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
module.exports["ANIMATE_TIME_SEC"] = $674e09754a51af28$export$19ffb24f8071504;
module.exports["PageTreeLoader"] = $674e09754a51af28$export$10d5dbd9dd81149f;
module.exports["PageTreeLoaderOnHover"] = $674e09754a51af28$export$8ce7795bff922b41;
module.exports["PageTree"] = $674e09754a51af28$export$73500bf5f2e2b0c4;

});

parcelRegister("igNnM", function(module, exports) {

let $036eb5ca1fd56b16$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $036eb5ca1fd56b16$var$load("aszGy"),
    $036eb5ca1fd56b16$var$load("klApM"),
    $036eb5ca1fd56b16$var$load("eQgf0"),
    $036eb5ca1fd56b16$var$load("6wr18"),
    $036eb5ca1fd56b16$var$load("e4XZ1"),
    $036eb5ca1fd56b16$var$load("5ppK3"),
    $036eb5ca1fd56b16$var$load("an06t"),
    $036eb5ca1fd56b16$var$load("ajt6g"),
    $036eb5ca1fd56b16$var$load("4mgLr"),
    $036eb5ca1fd56b16$var$load("19uFC"),
    $036eb5ca1fd56b16$var$load("28l1x"),
    $036eb5ca1fd56b16$var$load("ffEVr"),
    $036eb5ca1fd56b16$var$load("iNa18"),
    $036eb5ca1fd56b16$var$load("hogcU"),
    $036eb5ca1fd56b16$var$load("4UuEP"),
    $036eb5ca1fd56b16$var$load("75xVF"),
    $036eb5ca1fd56b16$var$load("4izLy"),
    $036eb5ca1fd56b16$var$load("hhss7"),
    $036eb5ca1fd56b16$var$load("Wowvf"),
    $036eb5ca1fd56b16$var$load("7EorR"),
    $036eb5ca1fd56b16$var$load("ltXeo")
]).then(()=>parcelRequire('bbZCI'));

});

parcelRegister("j3kZx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $748c02fb00e52ac9$export$a0aa95d2fbef03e8 = ({ sectionName: sectionName, collapsedByDefault: collapsedByDefault = false, forceExpand: forceExpand = false })=>{
    const [isExpandedManually, setIsExpandedManually] = (0, $42omo.useState)();
    const isDefaultExpanded = (0, $42omo.useMemo)(()=>$748c02fb00e52ac9$var$getExpandedStateBySpace(sectionName, collapsedByDefault), [
        sectionName,
        collapsedByDefault
    ]);
    const hasManualExpansion = isExpandedManually !== undefined;
    const isExpanded = hasManualExpansion ? isExpandedManually : forceExpand || isDefaultExpanded;
    const onExpansionToggle = (0, $42omo.useCallback)((newIsExpanded)=>{
        setIsExpandedManually(newIsExpanded);
        $748c02fb00e52ac9$var$updateExpandedStateBySpace(sectionName, newIsExpanded);
    }, [
        sectionName
    ]);
    return {
        isExpanded: isExpanded,
        onExpansionToggle: onExpansionToggle
    };
};
const $748c02fb00e52ac9$var$getExpandedStateBySpace = (sectionName, collapsedByDefault)=>{
    if ((0, $17wUi.confluenceLocalStorageInstance) && (0, $17wUi.confluenceLocalStorageInstance).doesContain((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES)) {
        const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES);
        if (typeof sideNavExpansionStates[sectionName] === 'boolean') return sideNavExpansionStates[sectionName];
    }
    return !collapsedByDefault;
};
const $748c02fb00e52ac9$var$updateExpandedStateBySpace = (sectionName, isExpanded)=>{
    if (!(0, $17wUi.confluenceLocalStorageInstance)) return;
    const sideNavExpansionStates = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES) || {};
    (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES, {
        ...sideNavExpansionStates,
        [sectionName]: isExpanded
    });
};
module.exports["useSpacePersistentExpansion"] = $748c02fb00e52ac9$export$a0aa95d2fbef03e8;

});


//# sourceMappingURL=SpaceNavigationContent.172b01b8.js.map
